(window["webpackJsonp"] = window["webpackJsonp"] || []).push([["main"],{

/***/ "./$$_lazy_route_resource lazy recursive":
/*!******************************************************!*\
  !*** ./$$_lazy_route_resource lazy namespace object ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function webpackEmptyAsyncContext(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncaught exception popping up in devtools
	return Promise.resolve().then(function() {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	});
}
webpackEmptyAsyncContext.keys = function() { return []; };
webpackEmptyAsyncContext.resolve = webpackEmptyAsyncContext;
module.exports = webpackEmptyAsyncContext;
webpackEmptyAsyncContext.id = "./$$_lazy_route_resource lazy recursive";

/***/ }),

/***/ "./node_modules/base64-js/index.js":
/*!*****************************************!*\
  !*** ./node_modules/base64-js/index.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(
      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
    ))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),

/***/ "./node_modules/buffer/index.js":
/*!**************************************!*\
  !*** ./node_modules/buffer/index.js ***!
  \**************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(/*! base64-js */ "./node_modules/base64-js/index.js")
var ieee754 = __webpack_require__(/*! ieee754 */ "./node_modules/ieee754/index.js")
var isArray = __webpack_require__(/*! isarray */ "./node_modules/isarray/index.js")

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/ieee754/index.js":
/*!***************************************!*\
  !*** ./node_modules/ieee754/index.js ***!
  \***************************************/
/*! no static exports found */
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),

/***/ "./node_modules/isarray/index.js":
/*!***************************************!*\
  !*** ./node_modules/isarray/index.js ***!
  \***************************************/
/*! no static exports found */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),

/***/ "./node_modules/moment/locale sync recursive ^\\.\\/.*$":
/*!**************************************************!*\
  !*** ./node_modules/moment/locale sync ^\.\/.*$ ***!
  \**************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "./node_modules/moment/locale/af.js",
	"./af.js": "./node_modules/moment/locale/af.js",
	"./ar": "./node_modules/moment/locale/ar.js",
	"./ar-dz": "./node_modules/moment/locale/ar-dz.js",
	"./ar-dz.js": "./node_modules/moment/locale/ar-dz.js",
	"./ar-kw": "./node_modules/moment/locale/ar-kw.js",
	"./ar-kw.js": "./node_modules/moment/locale/ar-kw.js",
	"./ar-ly": "./node_modules/moment/locale/ar-ly.js",
	"./ar-ly.js": "./node_modules/moment/locale/ar-ly.js",
	"./ar-ma": "./node_modules/moment/locale/ar-ma.js",
	"./ar-ma.js": "./node_modules/moment/locale/ar-ma.js",
	"./ar-sa": "./node_modules/moment/locale/ar-sa.js",
	"./ar-sa.js": "./node_modules/moment/locale/ar-sa.js",
	"./ar-tn": "./node_modules/moment/locale/ar-tn.js",
	"./ar-tn.js": "./node_modules/moment/locale/ar-tn.js",
	"./ar.js": "./node_modules/moment/locale/ar.js",
	"./az": "./node_modules/moment/locale/az.js",
	"./az.js": "./node_modules/moment/locale/az.js",
	"./be": "./node_modules/moment/locale/be.js",
	"./be.js": "./node_modules/moment/locale/be.js",
	"./bg": "./node_modules/moment/locale/bg.js",
	"./bg.js": "./node_modules/moment/locale/bg.js",
	"./bm": "./node_modules/moment/locale/bm.js",
	"./bm.js": "./node_modules/moment/locale/bm.js",
	"./bn": "./node_modules/moment/locale/bn.js",
	"./bn.js": "./node_modules/moment/locale/bn.js",
	"./bo": "./node_modules/moment/locale/bo.js",
	"./bo.js": "./node_modules/moment/locale/bo.js",
	"./br": "./node_modules/moment/locale/br.js",
	"./br.js": "./node_modules/moment/locale/br.js",
	"./bs": "./node_modules/moment/locale/bs.js",
	"./bs.js": "./node_modules/moment/locale/bs.js",
	"./ca": "./node_modules/moment/locale/ca.js",
	"./ca.js": "./node_modules/moment/locale/ca.js",
	"./cs": "./node_modules/moment/locale/cs.js",
	"./cs.js": "./node_modules/moment/locale/cs.js",
	"./cv": "./node_modules/moment/locale/cv.js",
	"./cv.js": "./node_modules/moment/locale/cv.js",
	"./cy": "./node_modules/moment/locale/cy.js",
	"./cy.js": "./node_modules/moment/locale/cy.js",
	"./da": "./node_modules/moment/locale/da.js",
	"./da.js": "./node_modules/moment/locale/da.js",
	"./de": "./node_modules/moment/locale/de.js",
	"./de-at": "./node_modules/moment/locale/de-at.js",
	"./de-at.js": "./node_modules/moment/locale/de-at.js",
	"./de-ch": "./node_modules/moment/locale/de-ch.js",
	"./de-ch.js": "./node_modules/moment/locale/de-ch.js",
	"./de.js": "./node_modules/moment/locale/de.js",
	"./dv": "./node_modules/moment/locale/dv.js",
	"./dv.js": "./node_modules/moment/locale/dv.js",
	"./el": "./node_modules/moment/locale/el.js",
	"./el.js": "./node_modules/moment/locale/el.js",
	"./en-SG": "./node_modules/moment/locale/en-SG.js",
	"./en-SG.js": "./node_modules/moment/locale/en-SG.js",
	"./en-au": "./node_modules/moment/locale/en-au.js",
	"./en-au.js": "./node_modules/moment/locale/en-au.js",
	"./en-ca": "./node_modules/moment/locale/en-ca.js",
	"./en-ca.js": "./node_modules/moment/locale/en-ca.js",
	"./en-gb": "./node_modules/moment/locale/en-gb.js",
	"./en-gb.js": "./node_modules/moment/locale/en-gb.js",
	"./en-ie": "./node_modules/moment/locale/en-ie.js",
	"./en-ie.js": "./node_modules/moment/locale/en-ie.js",
	"./en-il": "./node_modules/moment/locale/en-il.js",
	"./en-il.js": "./node_modules/moment/locale/en-il.js",
	"./en-nz": "./node_modules/moment/locale/en-nz.js",
	"./en-nz.js": "./node_modules/moment/locale/en-nz.js",
	"./eo": "./node_modules/moment/locale/eo.js",
	"./eo.js": "./node_modules/moment/locale/eo.js",
	"./es": "./node_modules/moment/locale/es.js",
	"./es-do": "./node_modules/moment/locale/es-do.js",
	"./es-do.js": "./node_modules/moment/locale/es-do.js",
	"./es-us": "./node_modules/moment/locale/es-us.js",
	"./es-us.js": "./node_modules/moment/locale/es-us.js",
	"./es.js": "./node_modules/moment/locale/es.js",
	"./et": "./node_modules/moment/locale/et.js",
	"./et.js": "./node_modules/moment/locale/et.js",
	"./eu": "./node_modules/moment/locale/eu.js",
	"./eu.js": "./node_modules/moment/locale/eu.js",
	"./fa": "./node_modules/moment/locale/fa.js",
	"./fa.js": "./node_modules/moment/locale/fa.js",
	"./fi": "./node_modules/moment/locale/fi.js",
	"./fi.js": "./node_modules/moment/locale/fi.js",
	"./fo": "./node_modules/moment/locale/fo.js",
	"./fo.js": "./node_modules/moment/locale/fo.js",
	"./fr": "./node_modules/moment/locale/fr.js",
	"./fr-ca": "./node_modules/moment/locale/fr-ca.js",
	"./fr-ca.js": "./node_modules/moment/locale/fr-ca.js",
	"./fr-ch": "./node_modules/moment/locale/fr-ch.js",
	"./fr-ch.js": "./node_modules/moment/locale/fr-ch.js",
	"./fr.js": "./node_modules/moment/locale/fr.js",
	"./fy": "./node_modules/moment/locale/fy.js",
	"./fy.js": "./node_modules/moment/locale/fy.js",
	"./ga": "./node_modules/moment/locale/ga.js",
	"./ga.js": "./node_modules/moment/locale/ga.js",
	"./gd": "./node_modules/moment/locale/gd.js",
	"./gd.js": "./node_modules/moment/locale/gd.js",
	"./gl": "./node_modules/moment/locale/gl.js",
	"./gl.js": "./node_modules/moment/locale/gl.js",
	"./gom-latn": "./node_modules/moment/locale/gom-latn.js",
	"./gom-latn.js": "./node_modules/moment/locale/gom-latn.js",
	"./gu": "./node_modules/moment/locale/gu.js",
	"./gu.js": "./node_modules/moment/locale/gu.js",
	"./he": "./node_modules/moment/locale/he.js",
	"./he.js": "./node_modules/moment/locale/he.js",
	"./hi": "./node_modules/moment/locale/hi.js",
	"./hi.js": "./node_modules/moment/locale/hi.js",
	"./hr": "./node_modules/moment/locale/hr.js",
	"./hr.js": "./node_modules/moment/locale/hr.js",
	"./hu": "./node_modules/moment/locale/hu.js",
	"./hu.js": "./node_modules/moment/locale/hu.js",
	"./hy-am": "./node_modules/moment/locale/hy-am.js",
	"./hy-am.js": "./node_modules/moment/locale/hy-am.js",
	"./id": "./node_modules/moment/locale/id.js",
	"./id.js": "./node_modules/moment/locale/id.js",
	"./is": "./node_modules/moment/locale/is.js",
	"./is.js": "./node_modules/moment/locale/is.js",
	"./it": "./node_modules/moment/locale/it.js",
	"./it-ch": "./node_modules/moment/locale/it-ch.js",
	"./it-ch.js": "./node_modules/moment/locale/it-ch.js",
	"./it.js": "./node_modules/moment/locale/it.js",
	"./ja": "./node_modules/moment/locale/ja.js",
	"./ja.js": "./node_modules/moment/locale/ja.js",
	"./jv": "./node_modules/moment/locale/jv.js",
	"./jv.js": "./node_modules/moment/locale/jv.js",
	"./ka": "./node_modules/moment/locale/ka.js",
	"./ka.js": "./node_modules/moment/locale/ka.js",
	"./kk": "./node_modules/moment/locale/kk.js",
	"./kk.js": "./node_modules/moment/locale/kk.js",
	"./km": "./node_modules/moment/locale/km.js",
	"./km.js": "./node_modules/moment/locale/km.js",
	"./kn": "./node_modules/moment/locale/kn.js",
	"./kn.js": "./node_modules/moment/locale/kn.js",
	"./ko": "./node_modules/moment/locale/ko.js",
	"./ko.js": "./node_modules/moment/locale/ko.js",
	"./ku": "./node_modules/moment/locale/ku.js",
	"./ku.js": "./node_modules/moment/locale/ku.js",
	"./ky": "./node_modules/moment/locale/ky.js",
	"./ky.js": "./node_modules/moment/locale/ky.js",
	"./lb": "./node_modules/moment/locale/lb.js",
	"./lb.js": "./node_modules/moment/locale/lb.js",
	"./lo": "./node_modules/moment/locale/lo.js",
	"./lo.js": "./node_modules/moment/locale/lo.js",
	"./lt": "./node_modules/moment/locale/lt.js",
	"./lt.js": "./node_modules/moment/locale/lt.js",
	"./lv": "./node_modules/moment/locale/lv.js",
	"./lv.js": "./node_modules/moment/locale/lv.js",
	"./me": "./node_modules/moment/locale/me.js",
	"./me.js": "./node_modules/moment/locale/me.js",
	"./mi": "./node_modules/moment/locale/mi.js",
	"./mi.js": "./node_modules/moment/locale/mi.js",
	"./mk": "./node_modules/moment/locale/mk.js",
	"./mk.js": "./node_modules/moment/locale/mk.js",
	"./ml": "./node_modules/moment/locale/ml.js",
	"./ml.js": "./node_modules/moment/locale/ml.js",
	"./mn": "./node_modules/moment/locale/mn.js",
	"./mn.js": "./node_modules/moment/locale/mn.js",
	"./mr": "./node_modules/moment/locale/mr.js",
	"./mr.js": "./node_modules/moment/locale/mr.js",
	"./ms": "./node_modules/moment/locale/ms.js",
	"./ms-my": "./node_modules/moment/locale/ms-my.js",
	"./ms-my.js": "./node_modules/moment/locale/ms-my.js",
	"./ms.js": "./node_modules/moment/locale/ms.js",
	"./mt": "./node_modules/moment/locale/mt.js",
	"./mt.js": "./node_modules/moment/locale/mt.js",
	"./my": "./node_modules/moment/locale/my.js",
	"./my.js": "./node_modules/moment/locale/my.js",
	"./nb": "./node_modules/moment/locale/nb.js",
	"./nb.js": "./node_modules/moment/locale/nb.js",
	"./ne": "./node_modules/moment/locale/ne.js",
	"./ne.js": "./node_modules/moment/locale/ne.js",
	"./nl": "./node_modules/moment/locale/nl.js",
	"./nl-be": "./node_modules/moment/locale/nl-be.js",
	"./nl-be.js": "./node_modules/moment/locale/nl-be.js",
	"./nl.js": "./node_modules/moment/locale/nl.js",
	"./nn": "./node_modules/moment/locale/nn.js",
	"./nn.js": "./node_modules/moment/locale/nn.js",
	"./pa-in": "./node_modules/moment/locale/pa-in.js",
	"./pa-in.js": "./node_modules/moment/locale/pa-in.js",
	"./pl": "./node_modules/moment/locale/pl.js",
	"./pl.js": "./node_modules/moment/locale/pl.js",
	"./pt": "./node_modules/moment/locale/pt.js",
	"./pt-br": "./node_modules/moment/locale/pt-br.js",
	"./pt-br.js": "./node_modules/moment/locale/pt-br.js",
	"./pt.js": "./node_modules/moment/locale/pt.js",
	"./ro": "./node_modules/moment/locale/ro.js",
	"./ro.js": "./node_modules/moment/locale/ro.js",
	"./ru": "./node_modules/moment/locale/ru.js",
	"./ru.js": "./node_modules/moment/locale/ru.js",
	"./sd": "./node_modules/moment/locale/sd.js",
	"./sd.js": "./node_modules/moment/locale/sd.js",
	"./se": "./node_modules/moment/locale/se.js",
	"./se.js": "./node_modules/moment/locale/se.js",
	"./si": "./node_modules/moment/locale/si.js",
	"./si.js": "./node_modules/moment/locale/si.js",
	"./sk": "./node_modules/moment/locale/sk.js",
	"./sk.js": "./node_modules/moment/locale/sk.js",
	"./sl": "./node_modules/moment/locale/sl.js",
	"./sl.js": "./node_modules/moment/locale/sl.js",
	"./sq": "./node_modules/moment/locale/sq.js",
	"./sq.js": "./node_modules/moment/locale/sq.js",
	"./sr": "./node_modules/moment/locale/sr.js",
	"./sr-cyrl": "./node_modules/moment/locale/sr-cyrl.js",
	"./sr-cyrl.js": "./node_modules/moment/locale/sr-cyrl.js",
	"./sr.js": "./node_modules/moment/locale/sr.js",
	"./ss": "./node_modules/moment/locale/ss.js",
	"./ss.js": "./node_modules/moment/locale/ss.js",
	"./sv": "./node_modules/moment/locale/sv.js",
	"./sv.js": "./node_modules/moment/locale/sv.js",
	"./sw": "./node_modules/moment/locale/sw.js",
	"./sw.js": "./node_modules/moment/locale/sw.js",
	"./ta": "./node_modules/moment/locale/ta.js",
	"./ta.js": "./node_modules/moment/locale/ta.js",
	"./te": "./node_modules/moment/locale/te.js",
	"./te.js": "./node_modules/moment/locale/te.js",
	"./tet": "./node_modules/moment/locale/tet.js",
	"./tet.js": "./node_modules/moment/locale/tet.js",
	"./tg": "./node_modules/moment/locale/tg.js",
	"./tg.js": "./node_modules/moment/locale/tg.js",
	"./th": "./node_modules/moment/locale/th.js",
	"./th.js": "./node_modules/moment/locale/th.js",
	"./tl-ph": "./node_modules/moment/locale/tl-ph.js",
	"./tl-ph.js": "./node_modules/moment/locale/tl-ph.js",
	"./tlh": "./node_modules/moment/locale/tlh.js",
	"./tlh.js": "./node_modules/moment/locale/tlh.js",
	"./tr": "./node_modules/moment/locale/tr.js",
	"./tr.js": "./node_modules/moment/locale/tr.js",
	"./tzl": "./node_modules/moment/locale/tzl.js",
	"./tzl.js": "./node_modules/moment/locale/tzl.js",
	"./tzm": "./node_modules/moment/locale/tzm.js",
	"./tzm-latn": "./node_modules/moment/locale/tzm-latn.js",
	"./tzm-latn.js": "./node_modules/moment/locale/tzm-latn.js",
	"./tzm.js": "./node_modules/moment/locale/tzm.js",
	"./ug-cn": "./node_modules/moment/locale/ug-cn.js",
	"./ug-cn.js": "./node_modules/moment/locale/ug-cn.js",
	"./uk": "./node_modules/moment/locale/uk.js",
	"./uk.js": "./node_modules/moment/locale/uk.js",
	"./ur": "./node_modules/moment/locale/ur.js",
	"./ur.js": "./node_modules/moment/locale/ur.js",
	"./uz": "./node_modules/moment/locale/uz.js",
	"./uz-latn": "./node_modules/moment/locale/uz-latn.js",
	"./uz-latn.js": "./node_modules/moment/locale/uz-latn.js",
	"./uz.js": "./node_modules/moment/locale/uz.js",
	"./vi": "./node_modules/moment/locale/vi.js",
	"./vi.js": "./node_modules/moment/locale/vi.js",
	"./x-pseudo": "./node_modules/moment/locale/x-pseudo.js",
	"./x-pseudo.js": "./node_modules/moment/locale/x-pseudo.js",
	"./yo": "./node_modules/moment/locale/yo.js",
	"./yo.js": "./node_modules/moment/locale/yo.js",
	"./zh-cn": "./node_modules/moment/locale/zh-cn.js",
	"./zh-cn.js": "./node_modules/moment/locale/zh-cn.js",
	"./zh-hk": "./node_modules/moment/locale/zh-hk.js",
	"./zh-hk.js": "./node_modules/moment/locale/zh-hk.js",
	"./zh-tw": "./node_modules/moment/locale/zh-tw.js",
	"./zh-tw.js": "./node_modules/moment/locale/zh-tw.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./node_modules/moment/locale sync recursive ^\\.\\/.*$";

/***/ }),

/***/ "./node_modules/process/browser.js":
/*!*****************************************!*\
  !*** ./node_modules/process/browser.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/admin/admin.component.html":
/*!**********************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/admin/admin.component.html ***!
  \**********************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<mat-card>\n\n    <h2 class=\"mat-h1 reset\">Admin</h2>\n\n    <mat-card-content>\n        <table mat-table [dataSource]=\"usersDataSource\">\n\n            <ng-container matColumnDef=\"address\">\n                <th mat-header-cell *matHeaderCellDef>Address</th>\n                <td mat-cell *matCellDef=\"let element\">\n                    {{element.address}}\n                </td>\n            </ng-container>\n\n            <ng-container matColumnDef=\"data_creator\">\n                <th mat-header-cell *matHeaderCellDef> Creator </th>\n                <td mat-cell *matCellDef=\"let element\">\n                    {{element.data_creator}}\n                </td>\n            </ng-container>\n\n            <ng-container matColumnDef=\"metadata_creator\">\n                <th mat-header-cell *matHeaderCellDef> Meta Creator </th>\n                <td mat-cell *matCellDef=\"let element\">\n                    {{element.metadata_creator}}\n                </td>\n            </ng-container>\n\n            <ng-container matColumnDef=\"publisher\">\n                <th mat-header-cell *matHeaderCellDef> Publisher </th>\n                <td mat-cell *matCellDef=\"let element\">\n                    {{element.publisher}}\n                </td>\n            </ng-container>\n\n            <ng-container matColumnDef=\"customer\" stickyEnd>\n                <th mat-header-cell *matHeaderCellDef> Customer </th>\n                <td mat-cell *matCellDef=\"let element\">\n                    {{element.customer}}\n                </td>\n            </ng-container>\n\n            <tr mat-header-row *matHeaderRowDef=\"['address','data_creator','metadata_creator','publisher','customer']\">\n            </tr>\n            <tr mat-row\n                *matRowDef=\"let row; columns: ['address','data_creator','metadata_creator','publisher','customer'];\">\n            </tr>\n\n        </table>\n        <mat-paginator [pageSizeOptions]=\"[10,20]\" hidePageSize></mat-paginator>\n\n    </mat-card-content>\n</mat-card>\n\n<br />\n\n<!-- \n<mat-form-field appearance=\"outline\">\n    <mat-label>Outline form field</mat-label>\n    <input matInput placeholder=\"Placeholder\">\n</mat-form-field>\n\n<mat-form-field appearance=\"outline\">\n    <mat-label>Outline form field</mat-label>\n    <input matInput placeholder=\"Placeholder\">\n</mat-form-field>\n\n<button mat-stroked-button (click)=\"setUserRole()\">\n    Set User Role\n</button> -->");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html":
/*!**************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html ***!
  \**************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"sidenav-area\">\n\n  <!-- Header -->\n  <div class=\"toolbar\">\n\n    <mat-progress-bar *ngIf=\"app.progressbar.isVisible\" style=\"height:2px;\" color=\"accent\" mode=\"indeterminate\"></mat-progress-bar>\n\n    <mat-toolbar *ngIf=\"app.toolbar.isVisible\" [style.background-color]=\"app.toolbar.color\">\n      <h1 class=\"site-title\">Algedonic Loop</h1>\n      <div class=\"logo\"> </div>\n\n      <app-wallet></app-wallet>\n\n    </mat-toolbar>\n  </div>\n\n  <!-- Sidebar -->\n  <mat-sidenav-container>\n    <mat-sidenav #start mode=\"side\" [style.background-color]=\"app.sidenav.color\" [opened]=\"app.sidenav.isVisible\"\n      [fixedInViewport]=\"true\" [fixedTopGap]=\"65\" [fixedBottomGap]=\"0\">\n      <mat-nav-list>\n\n        <a *ngIf=\"app.menu.isCatalog\" mat-list-item routerLink=\"/catalog\">\n          Catalog\n        </a>\n\n        <a *ngIf=\"app.menu.isAudit\" mat-list-item routerLink=\"/audit\">\n          Audit trail\n        </a>\n\n        <a *ngIf=\"app.menu.isTransactions\" mat-list-item routerLink=\"/transactions\">\n          Transactions\n        </a>\n\n        <a *ngIf=\"app.menu.isAdmin\" mat-list-item routerLink=\"/admin\">\n          Admin\n        </a>\n\n\n        <!--\n          <a mat-list-item routerLink=\"/debug\">\n            Debug\n          </a>\n        -->\n\n      </mat-nav-list>\n\n    </mat-sidenav>\n\n    <!-- Content -->\n    <mat-sidenav-content [style.background-color]=\"app.sidenav.color\">\n      <div class=\"sidenav-content\">\n        <router-outlet></router-outlet>\n      </div>\n    </mat-sidenav-content>\n\n  </mat-sidenav-container>\n\n</div>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/audit/audit.component.html":
/*!**********************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/audit/audit.component.html ***!
  \**********************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<mat-card>\n\n    <h2 class=\"mat-h1 reset\">Audit trail</h2> \n\n    <mat-card-content>\n\n        <table mat-table [dataSource]=\"auditDataSource\">\n\n            <ng-container matColumnDef=\"time\">\n                <th mat-header-cell *matHeaderCellDef> Time </th>\n                <td mat-cell *matCellDef=\"let element\">\n                    {{element.time}}\n                </td>\n            </ng-container>\n\n            <ng-container matColumnDef=\"sender\">\n                <th mat-header-cell *matHeaderCellDef> User </th>\n                <td mat-cell *matCellDef=\"let element\">\n                    {{element.sender}}\n                </td>\n            </ng-container>\n\n            <ng-container matColumnDef=\"params\">\n                <th mat-header-cell *matHeaderCellDef> Action </th>\n                <td mat-cell *matCellDef=\"let element\">\n                    {{element.params}}\n                </td>\n            </ng-container>\n\n            <ng-container matColumnDef=\"data_id\">\n                <th mat-header-cell *matHeaderCellDef> Data ID </th>\n                <td mat-cell *matCellDef=\"let element\">\n                    {{element.data_id}}\n                </td>\n            </ng-container>\n\n            <tr mat-header-row *matHeaderRowDef=\"['time','sender','params','data_id']\">\n            </tr>\n            <tr mat-row *matRowDef=\"let row; columns: ['time','sender','params','data_id'];\">\n            </tr>\n\n        </table>\n        <mat-paginator [pageSizeOptions]=\"[10,20]\" hidePageSize></mat-paginator>\n\n        <!-- {{ audit | json }} -->\n\n    </mat-card-content>\n</mat-card>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/catalog/catalog.component.html":
/*!**************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/catalog/catalog.component.html ***!
  \**************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<mat-card>\n\n    <div style=\"display:flex;\">\n\n        <h2 class=\"mat-h1 reset\">Catalog</h2>\n        <div style=\"display: flex; width:100%;align-self:stretch;\"></div>\n        <button *ngIf=\"actions.isCreateData\" mat-stroked-button\n            style=\"color:#1abc9c;min-width: 145px;height: 30px;margin: 20px 25px 0px 0px;\" routerLink=\"/catalog/create\">\n            Create Data\n        </button>\n\n        <button *ngIf=\"actions.isCreateMetaData\" mat-stroked-button\n            style=\"color:#1abc9c;min-width: 145px;height: 30px;margin: 20px 25px 0px 0px;\" routerLink=\"/catalog/create\">\n            Create Meta Data\n        </button>\n    </div>\n\n\n    <mat-card-content>\n        <table mat-table [dataSource]=\"catalogDataSource\">\n\n            <ng-container matColumnDef=\"data_id\">\n                <th mat-header-cell *matHeaderCellDef> Data ID </th>\n                <td mat-cell *matCellDef=\"let element\">\n                    {{element.data_id}}\n                </td>\n            </ng-container>\n\n            <ng-container matColumnDef=\"is_data_public\">\n                <th mat-header-cell *matHeaderCellDef> Is Data Public </th>\n                <td mat-cell *matCellDef=\"let element\">\n                    {{element.is_data_public}}\n                </td>\n            </ng-container>\n\n            <ng-container matColumnDef=\"data_publisher\">\n                <th mat-header-cell *matHeaderCellDef> Data Publisher </th>\n                <td mat-cell *matCellDef=\"let element\">\n                    {{element.data_publisher}}\n                </td>\n            </ng-container>\n\n            <ng-container matColumnDef=\"data_creator\" stickyEnd>\n                <th mat-header-cell *matHeaderCellDef> Data Creator </th>\n                <td mat-cell *matCellDef=\"let element\">\n                    {{element.data_creator}}\n                </td>\n            </ng-container>\n\n            <ng-container matColumnDef=\"meta_data_id\" stickyEnd>\n                <th mat-header-cell *matHeaderCellDef> Meta Data ID </th>\n                <td mat-cell *matCellDef=\"let element\">\n                    {{element.meta_data_id}}\n                </td>\n            </ng-container>\n\n            <ng-container matColumnDef=\"keywords\" stickyEnd>\n                <th mat-header-cell *matHeaderCellDef> Keywords</th>\n                <td mat-cell *matCellDef=\"let element\">\n                    {{element.keywords}}\n                </td>\n            </ng-container>\n\n            <ng-container matColumnDef=\"data_id_2\">\n                <th mat-header-cell *matHeaderCellDef> </th>\n                <td mat-cell *matCellDef=\"let element\">\n                    <button *ngIf=\"actions.isPublish && element.is_data_public=='pending'\" mat-stroked-button\n                        style=\"color:#1abc9c\" (click)=\"allowPublication(element.data_id)\">\n                        Publish\n                    </button>\n                    <button *ngIf=\"actions.isRequestPublish && element.is_data_public=='no'\" mat-stroked-button\n                        style=\"color:#1abc9c\" (click)=\"requestPublication(element.data_id)\">\n                        Request Publication\n                    </button>\n                    <button *ngIf=\"actions.isBuy && element.is_data_public=='yes'\" mat-stroked-button\n                        style=\"color:#1abc9c\" (click)=\"buyData(element.data_id)\">\n                        Buy\n                    </button>\n                </td>\n            </ng-container>\n\n            <tr mat-header-row\n                *matHeaderRowDef=\"['data_id','is_data_public', 'data_publisher', 'meta_data_id', 'keywords','data_id_2']\">\n            </tr>\n            <tr mat-row\n                *matRowDef=\"let row; columns: ['data_id','is_data_public', 'data_publisher', 'meta_data_id','keywords','data_id_2'];\">\n            </tr>\n\n        </table>\n        <mat-paginator [pageSizeOptions]=\"[10,20]\" hidePageSize></mat-paginator>\n\n    </mat-card-content>\n\n</mat-card>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/create/create.component.html":
/*!************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/create/create.component.html ***!
  \************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<mat-card>\n    <div style=\"display:flex;\">\n\n        <h2 class=\"mat-h1 reset\" style=\"min-width:200px;\">Create</h2>\n\n        <div style=\"display: flex; width:100%;align-self:stretch;\"></div>\n\n        <div style=\"display: flex;\">\n            <mat-form-field appearance=\"outline\" style=\"margin: 15px 0px 0px 0px\">\n                <mat-label>Data ID</mat-label>\n                <input matInput [(ngModel)]=\"data_id\" placeholder=\"\">\n            </mat-form-field>\n\n            <mat-form-field *ngIf=\"wallet.selected.role=='meta_creator'\" appearance=\"outline\"\n                style=\"margin: 15px 0px 0px 20px\">\n                <mat-label>Meta Data ID</mat-label>\n                <input matInput [(ngModel)]=\"meta_data_id\" placeholder=\"\">\n            </mat-form-field>\n\n            <mat-form-field appearance=\"outline\" style=\"margin: 15px 20px 0px 20px\">\n                <mat-label>Keywords</mat-label>\n                <input matInput [(ngModel)]=\"keywords\" placeholder=\"\">\n            </mat-form-field>\n\n            <button *ngIf=\"wallet.selected.role=='creator'\" mat-stroked-button\n                style=\"color:#1abc9c;min-width: 145px;height: 30px;margin: 20px 25px 0px 0px;\" (click)=\"createData()\">\n                Create Data\n            </button>\n            <button *ngIf=\"wallet.selected.role=='meta_creator'\" mat-stroked-button\n                style=\"color:#1abc9c;min-width: 145px;height: 30px;margin: 20px 25px 0px 0px;\" (click)=\"createMetaData()\">\n                Create Meta Data\n            </button>\n        </div>\n\n    </div>\n</mat-card>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/debug/debug.component.html":
/*!**********************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/debug/debug.component.html ***!
  \**********************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<button mat-stroked-button (click)=\"sendTransaction()\">\n    Call smart contract\n</button>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/dialog/dialog.component.html":
/*!*******************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/shared/dialog/dialog.component.html ***!
  \*******************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<!-- TODO: fix styles -->\n<div class=\"dialog\" style=\"padding: 0px !important;min-width: 460px;\">\n\n    <mat-card class=\"dialog-warning\" style=\"border: 1px solid red;border-radius: 5px;width: 465px\">\n        <mat-card-header style=\"display: flex;align-items: center;justify-content: center;min-height: 65px;\">\n            <h2 class=\"mat-h1\" style=\"font-size: 20px;color: red;margin-left: -30px;\">\n                <!-- <svg-icon icon=\"warning\" scale=\"0.8\" style=\"vertical-align: 0.05em !important;\"></svg-icon>&nbsp; -->\n                {{ dialog.headline }}\n            </h2>\n        </mat-card-header>\n        <mat-card-content style=\"padding:initial\">\n\n            <span style=\"display: block;margin: 20px 20px 5px 20px;font-weight: 500; text-align: center;\">\n                <span style=\"font-weight: 400;\">\n\n                    <span *ngFor=\"let content of dialog.content\">\n                        <ul *ngFor=\"let error of content\" style=\"text-align: left;list-style-type: none;\">\n                            <li *ngFor=\"let line of error\">\n                                <div *ngIf=\"line.name!='with'\">\n                                    <span style=\"font-weight: 500;\">{{line.name}}</span>: {{line.value}}\n                                </div>\n                                <div *ngIf=\"line.name=='with'\">\n                                    <span style=\"font-weight: 500;\">{{line.name}}</span>: {{line.value | json}}\n                                </div>\n                            </li>\n                        </ul>\n                    </span>\n\n                </span>\n\n                <br />\n                <br />\n\n                <button class=\"dialog\" mat-flat-button (click)=\"closeDialog()\">\n                    <svg-icon icon=\"ok\" scale=\"1.2\"></svg-icon>&nbsp;\n                    Done&nbsp;&nbsp;&nbsp;\n                </button>\n\n                <br />\n\n            </span>\n\n        </mat-card-content>\n    </mat-card>\n\n</div>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/svg-icon/svg-icon.component.html":
/*!***********************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/shared/svg-icon/svg-icon.component.html ***!
  \***********************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<img class=\"svg-icon\" src=\"./assets/icon/{{icon}}.svg\" [style.transform]=\"'scale(' + scale + ')'\">\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/transactions/transactions.component.html":
/*!************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/transactions/transactions.component.html ***!
  \************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<mat-card>\n\n    <h2 class=\"mat-h1 reset\">Transactions</h2> \n\n    <mat-card-content>\n\n        <table mat-table [dataSource]=\"transactionsDataSource\">\n\n            <ng-container matColumnDef=\"transaction_id\">\n                <th mat-header-cell *matHeaderCellDef> Transaction ID </th>\n                <td mat-cell *matCellDef=\"let element\">\n                    {{ element.transaction_id }}\n                </td>\n            </ng-container>\n\n            <ng-container matColumnDef=\"data_id\">\n                <th mat-header-cell *matHeaderCellDef> Data ID </th>\n                <td mat-cell *matCellDef=\"let element\">\n                    {{ element.data_id }}\n                </td>\n            </ng-container>\n\n\n            <ng-container matColumnDef=\"customer\">\n                <th mat-header-cell *matHeaderCellDef> Customer </th>\n                <td mat-cell *matCellDef=\"let element\">\n                    {{ element.customer }}\n                </td>\n            </ng-container>\n\n            <ng-container matColumnDef=\"signature\">\n                    <th mat-header-cell *matHeaderCellDef> Signature </th>\n                    <td mat-cell *matCellDef=\"let element\">\n                        {{ element.signature }}\n                    </td>\n            </ng-container>\n\n            <tr mat-header-row *matHeaderRowDef=\"['transaction_id','data_id','customer','signature']\">\n            </tr>\n            <tr mat-row *matRowDef=\"let row; columns: ['transaction_id','data_id','customer','signature'];\">\n            </tr>\n            \n        </table>\n        <mat-paginator [pageSizeOptions]=\"[10,20]\" hidePageSize></mat-paginator>\n\n    </mat-card-content>\n</mat-card>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/wallet/wallet.component.html":
/*!************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/wallet/wallet.component.html ***!
  \************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n<button class=\"wallet-button\" mat-button [matMenuTriggerFor]=\"menu\">{{this.wallet.name}}</button>\n\n<mat-menu #menu=\"matMenu\" >\n    <div *ngFor=\"let wallet of wallets\">\n        <button mat-menu-item (click)=\"walletChange(wallet)\" >\n            <b>{{wallet.name}}</b> | {{wallet.publicKeyHash}}\n        </button>\n    </div>\n</mat-menu>");

/***/ }),

/***/ "./node_modules/tslib/tslib.es6.js":
/*!*****************************************!*\
  !*** ./node_modules/tslib/tslib.es6.js ***!
  \*****************************************/
/*! exports provided: __extends, __assign, __rest, __decorate, __param, __metadata, __awaiter, __generator, __exportStar, __values, __read, __spread, __spreadArrays, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__extends", function() { return __extends; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__rest", function() { return __rest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__decorate", function() { return __decorate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__param", function() { return __param; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__metadata", function() { return __metadata; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__awaiter", function() { return __awaiter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__generator", function() { return __generator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__exportStar", function() { return __exportStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__values", function() { return __values; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__read", function() { return __read; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spread", function() { return __spread; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spreadArrays", function() { return __spreadArrays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__await", function() { return __await; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncGenerator", function() { return __asyncGenerator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncDelegator", function() { return __asyncDelegator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncValues", function() { return __asyncValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__makeTemplateObject", function() { return __makeTemplateObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importStar", function() { return __importStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importDefault", function() { return __importDefault; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),

/***/ "./node_modules/webpack/buildin/global.js":
/*!***********************************!*\
  !*** (webpack)/buildin/global.js ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "./src/app/admin/admin.component.css":
/*!*******************************************!*\
  !*** ./src/app/admin/admin.component.css ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2FkbWluL2FkbWluLmNvbXBvbmVudC5jc3MifQ== */");

/***/ }),

/***/ "./src/app/admin/admin.component.ts":
/*!******************************************!*\
  !*** ./src/app/admin/admin.component.ts ***!
  \******************************************/
/*! exports provided: AdminComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AdminComponent", function() { return AdminComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _ngrx_store__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @ngrx/store */ "./node_modules/@ngrx/store/fesm2015/store.js");
/* harmony import */ var _angular_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/material */ "./node_modules/@angular/material/esm2015/material.js");




let AdminComponent = class AdminComponent {
    constructor(store) {
        this.store = store;
    }
    ngOnInit() {
        // get users data from smart contrat
        this.store.dispatch({
            type: 'ADMIN_USERS_LOAD',
        });
        // subscribe to app state
        this.store.select('admin')
            .subscribe(data => {
            this.users = data.ids.map(id => (Object.assign({ id }, data.entities[id])));
            this.usersDataSource = new _angular_material__WEBPACK_IMPORTED_MODULE_3__["MatTableDataSource"](this.users);
            this.usersDataSource.paginator = this.paginator;
        });
    }
    setUserRole() {
        this.store.dispatch({
            type: 'TEZOS_SEND_TRANSACTION',
        });
    }
};
AdminComponent.ctorParameters = () => [
    { type: _ngrx_store__WEBPACK_IMPORTED_MODULE_2__["Store"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])(_angular_material__WEBPACK_IMPORTED_MODULE_3__["MatPaginator"], { static: true })
], AdminComponent.prototype, "paginator", void 0);
AdminComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-admin',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./admin.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/admin/admin.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./admin.component.css */ "./src/app/admin/admin.component.css")).default]
    })
], AdminComponent);



/***/ }),

/***/ "./src/app/admin/admin.effects.ts":
/*!****************************************!*\
  !*** ./src/app/admin/admin.effects.ts ***!
  \****************************************/
/*! exports provided: AdminEffects */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AdminEffects", function() { return AdminEffects; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _ngrx_effects__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @ngrx/effects */ "./node_modules/@ngrx/effects/fesm2015/effects.js");
/* harmony import */ var _ngrx_store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @ngrx/store */ "./node_modules/@ngrx/store/fesm2015/store.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");






let AdminEffects = class AdminEffects {
    constructor(actions$, store, http) {
        this.actions$ = actions$;
        this.store = store;
        this.http = http;
        // get admin data from users big map
        this.AdminUsersLoadWallet$ = this.actions$.pipe(Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_2__["ofType"])('ADMIN_USERS_LOAD', 'TEZOS_SEND_TRANSACTION_SUCCESS'), 
        // get state from store
        Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["withLatestFrom"])(this.store, (action, state) => ({ action, state })), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["flatMap"])(({ action, state }) => 
        // this.http.get(state.app.tezos.node.url + '/chains/main/blocks/head/context/raw/json/big_maps/index/630/contents/?depth=5')
        this.http.get(state.app.tezos.node.url + '/chains/main/blocks/head/context/raw/json/big_maps/index/655/contents/?depth=5')), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])((response) => ({ type: 'ADMIN_USERS_LOAD_SUCCESS', payload: response })), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["catchError"])((error, caught) => {
            console.error(error.message);
            this.store.dispatch({
                type: 'ADMIN_USERS_LOAD_ERROR',
                payload: error.message,
            });
            return caught;
        }));
    }
};
AdminEffects.ctorParameters = () => [
    { type: _ngrx_effects__WEBPACK_IMPORTED_MODULE_2__["Actions"] },
    { type: _ngrx_store__WEBPACK_IMPORTED_MODULE_3__["Store"] },
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_5__["HttpClient"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_2__["Effect"])()
], AdminEffects.prototype, "AdminUsersLoadWallet$", void 0);
AdminEffects = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])()
], AdminEffects);



/***/ }),

/***/ "./src/app/admin/admin.reducer.ts":
/*!****************************************!*\
  !*** ./src/app/admin/admin.reducer.ts ***!
  \****************************************/
/*! exports provided: reducer, prefix, bs58checkEncode, hexToArrayBuffer */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reducer", function() { return reducer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "prefix", function() { return prefix; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bs58checkEncode", function() { return bs58checkEncode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hexToArrayBuffer", function() { return hexToArrayBuffer; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var bs58check__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! bs58check */ "./node_modules/bs58check/index.js");
/* harmony import */ var bs58check__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(bs58check__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var buffer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! buffer */ "./node_modules/buffer/index.js");
/* harmony import */ var buffer__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(buffer__WEBPACK_IMPORTED_MODULE_2__);



const initialState = {
    ids: [],
    entities: {},
    page: 0,
    itemsPerPage: 10,
    itemsTotalCount: 0
};
function reducer(state = initialState, action) {
    switch (action.type) {
        case 'ADMIN_USERS_LOAD_SUCCESS': {
            return {
                ids: [
                    ...action.payload.map(admin => admin[0])
                ],
                entities: action.payload.reduce((accumulator, admin) => {
                    const address = admin[1].args[0].args[0].args[0].bytes;
                    return Object.assign({}, accumulator, { 
                        // hash of tz address
                        [admin[0]]: {
                            address: bs58checkEncode(prefix.tz1, hexToArrayBuffer(address.substr(4))),
                            data_creator: admin[1].args[0].args[0].args[1].prim === "True" ? true : false,
                            metadata_creator: admin[1].args[0].args[1].args[0].prim === "True" ? true : false,
                            publisher: admin[1].args[0].args[1].args[1].prim === "True" ? true : false,
                            customer: admin[1].args[1].prim === "True" ? true : false,
                        } });
                }, {}),
            };
        }
        default:
            return state;
    }
}
/**
 * Prefix table
 */
const prefix = {
    tz1: new Uint8Array([6, 161, 159]),
    tz2: new Uint8Array([6, 161, 161]),
    tz3: new Uint8Array([6, 161, 164]),
    KT1: new Uint8Array([2, 90, 121]),
    B: new Uint8Array([1, 52]),
    edpk: new Uint8Array([13, 15, 37, 217]),
    sppk: new Uint8Array([3, 254, 226, 86]),
    p2pk: new Uint8Array([3, 178, 139, 127]),
    edsk64: new Uint8Array([43, 246, 78, 7]),
    edsk32: new Uint8Array([13, 15, 58, 7]),
    edsig: new Uint8Array([9, 245, 205, 134, 18]),
    operation: new Uint8Array([5, 116]),
};
function bs58checkEncode(prefix, payload) {
    const n = new Uint8Array(prefix.length + payload.length);
    n.set(prefix);
    n.set(payload, prefix.length);
    return bs58check__WEBPACK_IMPORTED_MODULE_1__["encode"](buffer__WEBPACK_IMPORTED_MODULE_2__["Buffer"].from(n));
}
function hexToArrayBuffer(hex) {
    var view = new Uint8Array(hex.length / 2);
    for (var i = 0; i < hex.length; i += 2) {
        view[i / 2] = parseInt(hex.substring(i, i + 2), 16);
    }
    return view;
}


/***/ }),

/***/ "./src/app/app.component.css":
/*!***********************************!*\
  !*** ./src/app/app.component.css ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".logo {\n    display: block;\n    margin: 0 auto;\n    height: 2rem;\n    width: 10rem;\n    background: url('Black.svg') no-repeat center;\n    background-size: contain;\n   }\n\n.site-title {\n  text-indent: -9999px;\n  height: 1rem;\n  width: 130px;\n  background: url('algedonic-loop-icon.svg') no-repeat;\n  background-size: contain;\n}\n\n.link {\n  color: #000000;\n  text-decoration: none;\n  font-weight: normal;\n  font-size: 14px;\n}\n\n.filler-content {\n    display: flex;\n    align-self:stretch;\n    width: 100%;\n}\n\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvYXBwLmNvbXBvbmVudC5jc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7SUFDSSxjQUFjO0lBQ2QsY0FBYztJQUNkLFlBQVk7SUFDWixZQUFZO0lBQ1osNkNBQThEO0lBQzlELHdCQUF3QjtHQUN6Qjs7QUFFSDtFQUNFLG9CQUFvQjtFQUNwQixZQUFZO0VBQ1osWUFBWTtFQUNaLG9EQUFxRTtFQUNyRSx3QkFBd0I7QUFDMUI7O0FBRUE7RUFDRSxjQUFjO0VBQ2QscUJBQXFCO0VBQ3JCLG1CQUFtQjtFQUNuQixlQUFlO0FBQ2pCOztBQUVBO0lBQ0ksYUFBYTtJQUNiLGtCQUFrQjtJQUNsQixXQUFXO0FBQ2YiLCJmaWxlIjoic3JjL2FwcC9hcHAuY29tcG9uZW50LmNzcyIsInNvdXJjZXNDb250ZW50IjpbIi5sb2dvIHtcbiAgICBkaXNwbGF5OiBibG9jaztcbiAgICBtYXJnaW46IDAgYXV0bztcbiAgICBoZWlnaHQ6IDJyZW07XG4gICAgd2lkdGg6IDEwcmVtO1xuICAgIGJhY2tncm91bmQ6IHVybCgnLi4vYXNzZXRzL2ltYWdlcy9CbGFjay5zdmcnKSBuby1yZXBlYXQgY2VudGVyO1xuICAgIGJhY2tncm91bmQtc2l6ZTogY29udGFpbjtcbiAgIH1cblxuLnNpdGUtdGl0bGUge1xuICB0ZXh0LWluZGVudDogLTk5OTlweDtcbiAgaGVpZ2h0OiAxcmVtO1xuICB3aWR0aDogMTMwcHg7XG4gIGJhY2tncm91bmQ6IHVybCgnLi4vYXNzZXRzL2ltYWdlcy9hbGdlZG9uaWMtbG9vcC1pY29uLnN2ZycpIG5vLXJlcGVhdDtcbiAgYmFja2dyb3VuZC1zaXplOiBjb250YWluO1xufVxuXG4ubGluayB7XG4gIGNvbG9yOiAjMDAwMDAwO1xuICB0ZXh0LWRlY29yYXRpb246IG5vbmU7XG4gIGZvbnQtd2VpZ2h0OiBub3JtYWw7XG4gIGZvbnQtc2l6ZTogMTRweDtcbn1cblxuLmZpbGxlci1jb250ZW50IHtcbiAgICBkaXNwbGF5OiBmbGV4O1xuICAgIGFsaWduLXNlbGY6c3RyZXRjaDtcbiAgICB3aWR0aDogMTAwJTtcbn1cbiJdfQ== */");

/***/ }),

/***/ "./src/app/app.component.ts":
/*!**********************************!*\
  !*** ./src/app/app.component.ts ***!
  \**********************************/
/*! exports provided: AppComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppComponent", function() { return AppComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _ngrx_store__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @ngrx/store */ "./node_modules/@ngrx/store/fesm2015/store.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");




let AppComponent = class AppComponent {
    constructor(store, router) {
        this.store = store;
        this.router = router;
    }
    ngOnInit() {
        // subscribe to app state
        this.store.select('app')
            .subscribe(data => {
            this.app = data;
        });
        this.store.dispatch({
            type: 'WALLET_CHANGE',
            payload: {
                // name: 'Publisher',
                // role: 'publisher',
                // secretKey: 'edsk3neLbXv2n2L4V3zR24cgWCFEWqzwPY5cp7K5N96Jwuq7ov6qfp',
                // publicKey: 'edpku4h8cY57pWdxBWuoDKBRQg6MjSnV2oNAPyVqi3x9rSoUKNf5LE',
                // publicKeyHash: 'tz1epncWCL1vGFz1UgyTZHdE4v1u417ETJa9'
                name: 'Creator',
                role: 'creator',
                secretKey: 'edsk4Q6r9wnDcwnnonojc1HYhNRfpk2MpsRF5VuJc5VGhs9K1XyXr4',
                publicKey: 'edpkvPUCDv4DYC37FvpXvc1ZfPYNVhTzU2xiqUTKDPDaQFmPw5UsA8',
                publicKeyHash: 'tz1VXDYKscRsAWm2ESVFQa3dzdWdapbSbDcm',
            }
        });
    }
};
AppComponent.ctorParameters = () => [
    { type: _ngrx_store__WEBPACK_IMPORTED_MODULE_2__["Store"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_3__["Router"] }
];
AppComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-root',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./app.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./app.component.css */ "./src/app/app.component.css")).default]
    })
], AppComponent);



/***/ }),

/***/ "./src/app/app.effects.ts":
/*!********************************!*\
  !*** ./src/app/app.effects.ts ***!
  \********************************/
/*! exports provided: AllEffects */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AllEffects", function() { return AllEffects; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _ngrx_effects__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @ngrx/effects */ "./node_modules/@ngrx/effects/fesm2015/effects.js");
/* harmony import */ var _ngrx_store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @ngrx/store */ "./node_modules/@ngrx/store/fesm2015/store.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");






let AllEffects = class AllEffects {
    constructor(actions$, store) {
        this.actions$ = actions$;
        this.store = store;
        this.Init$ = Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["defer"])(() => {
            // disable online data 
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["of"])({ type: 'HEARTBEAT' });
        });
        // effect to debug falling outside of zone
        this.ZoneDebugEffects$ = this.actions$
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["withLatestFrom"])(this.store, (action, state) => ({ action, state })), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["tap"])(({ action, state }) => {
            if (_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgZone"].isInAngularZone() === false) {
                console.error('[zone][debug]', _angular_core__WEBPACK_IMPORTED_MODULE_1__["NgZone"].isInAngularZone(), action);
            }
        }));
    }
};
AllEffects.ctorParameters = () => [
    { type: _ngrx_effects__WEBPACK_IMPORTED_MODULE_2__["Actions"] },
    { type: _ngrx_store__WEBPACK_IMPORTED_MODULE_3__["Store"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_2__["Effect"])()
], AllEffects.prototype, "Init$", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_2__["Effect"])({ dispatch: false })
], AllEffects.prototype, "ZoneDebugEffects$", void 0);
AllEffects = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])()
], AllEffects);



/***/ }),

/***/ "./src/app/app.module.ts":
/*!*******************************!*\
  !*** ./src/app/app.module.ts ***!
  \*******************************/
/*! exports provided: AppModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppModule", function() { return AppModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _app_component__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./app.component */ "./src/app/app.component.ts");
/* harmony import */ var _app_routing__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./app.routing */ "./src/app/app.routing.ts");
/* harmony import */ var _ngrx_store__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @ngrx/store */ "./node_modules/@ngrx/store/fesm2015/store.js");
/* harmony import */ var _ngrx_effects__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @ngrx/effects */ "./node_modules/@ngrx/effects/fesm2015/effects.js");
/* harmony import */ var _app_reducers__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./app.reducers */ "./src/app/app.reducers.ts");
/* harmony import */ var _ngrx_router_store__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @ngrx/router-store */ "./node_modules/@ngrx/router-store/fesm2015/router-store.js");
/* harmony import */ var _ngrx_store_devtools__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @ngrx/store-devtools */ "./node_modules/@ngrx/store-devtools/fesm2015/store-devtools.js");
/* harmony import */ var _environments_environment__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../environments/environment */ "./src/environments/environment.ts");
/* harmony import */ var _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @angular/platform-browser/animations */ "./node_modules/@angular/platform-browser/fesm2015/animations.js");
/* harmony import */ var _angular_material__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! @angular/material */ "./node_modules/@angular/material/esm2015/material.js");
/* harmony import */ var _debug_debug_component__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./debug/debug.component */ "./src/app/debug/debug.component.ts");
/* harmony import */ var _app_effects__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./app.effects */ "./src/app/app.effects.ts");
/* harmony import */ var _audit_audit_effects__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./audit/audit.effects */ "./src/app/audit/audit.effects.ts");
/* harmony import */ var _admin_admin_effects__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./admin/admin.effects */ "./src/app/admin/admin.effects.ts");
/* harmony import */ var _catalog_catalog_effects__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./catalog/catalog.effects */ "./src/app/catalog/catalog.effects.ts");
/* harmony import */ var _transactions_transactions_effects__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./transactions/transactions.effects */ "./src/app/transactions/transactions.effects.ts");
/* harmony import */ var _wallet_wallet_effects__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./wallet/wallet.effects */ "./src/app/wallet/wallet.effects.ts");
/* harmony import */ var _debug_debug_effects__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./debug/debug.effects */ "./src/app/debug/debug.effects.ts");
/* harmony import */ var _shared_dialog_dialog_effects__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ./shared/dialog/dialog.effects */ "./src/app/shared/dialog/dialog.effects.ts");
/* harmony import */ var _shared_dialog_dialog_component__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ./shared/dialog/dialog.component */ "./src/app/shared/dialog/dialog.component.ts");
/* harmony import */ var _shared_svg_icon_svg_icon_component__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ./shared/svg-icon/svg-icon.component */ "./src/app/shared/svg-icon/svg-icon.component.ts");
/* harmony import */ var _admin_admin_component__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ./admin/admin.component */ "./src/app/admin/admin.component.ts");
/* harmony import */ var _catalog_catalog_component__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ./catalog/catalog.component */ "./src/app/catalog/catalog.component.ts");
/* harmony import */ var _transactions_transactions_component__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ./transactions/transactions.component */ "./src/app/transactions/transactions.component.ts");
/* harmony import */ var _audit_audit_component__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ./audit/audit.component */ "./src/app/audit/audit.component.ts");
/* harmony import */ var _wallet_wallet_component__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! ./wallet/wallet.component */ "./src/app/wallet/wallet.component.ts");
/* harmony import */ var _create_create_component__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! ./create/create.component */ "./src/app/create/create.component.ts");














// import { NoopAnimationsModule } from '@angular/platform-browser/animations'



















let AppModule = class AppModule {
};
AppModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["NgModule"])({
        declarations: [
            _app_component__WEBPACK_IMPORTED_MODULE_6__["AppComponent"],
            _debug_debug_component__WEBPACK_IMPORTED_MODULE_16__["DebugComponent"],
            _shared_dialog_dialog_component__WEBPACK_IMPORTED_MODULE_25__["DialogComponent"],
            _shared_svg_icon_svg_icon_component__WEBPACK_IMPORTED_MODULE_26__["SvgIconComponent"],
            _admin_admin_component__WEBPACK_IMPORTED_MODULE_27__["AdminComponent"],
            _catalog_catalog_component__WEBPACK_IMPORTED_MODULE_28__["CatalogComponent"],
            _transactions_transactions_component__WEBPACK_IMPORTED_MODULE_29__["TransactionsComponent"],
            _audit_audit_component__WEBPACK_IMPORTED_MODULE_30__["AuditComponent"],
            _wallet_wallet_component__WEBPACK_IMPORTED_MODULE_31__["WalletComponent"],
            _create_create_component__WEBPACK_IMPORTED_MODULE_32__["CreateComponent"]
        ],
        imports: [
            _angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__["BrowserModule"],
            _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_14__["BrowserAnimationsModule"],
            _angular_common_http__WEBPACK_IMPORTED_MODULE_4__["HttpClientModule"],
            _angular_forms__WEBPACK_IMPORTED_MODULE_5__["FormsModule"],
            _angular_router__WEBPACK_IMPORTED_MODULE_3__["RouterModule"].forRoot(_app_routing__WEBPACK_IMPORTED_MODULE_7__["AppRouting"], {
                //useHash:true
                preloadingStrategy: _angular_router__WEBPACK_IMPORTED_MODULE_3__["PreloadAllModules"]
            }),
            // Connects RouterModule with StoreModule
            _ngrx_router_store__WEBPACK_IMPORTED_MODULE_11__["StoreRouterConnectingModule"].forRoot({}),
            _ngrx_store__WEBPACK_IMPORTED_MODULE_8__["StoreModule"].forRoot(_app_reducers__WEBPACK_IMPORTED_MODULE_10__["reducers"], {
                metaReducers: _app_reducers__WEBPACK_IMPORTED_MODULE_10__["metaReducers"],
                runtimeChecks: {
                    strictStateImmutability: true,
                    strictActionImmutability: true
                }
            }),
            !_environments_environment__WEBPACK_IMPORTED_MODULE_13__["environment"].production ? _ngrx_store_devtools__WEBPACK_IMPORTED_MODULE_12__["StoreDevtoolsModule"].instrument({ maxAge: 25 }) : [],
            // Set side effects
            _ngrx_effects__WEBPACK_IMPORTED_MODULE_9__["EffectsModule"].forRoot([
                _app_effects__WEBPACK_IMPORTED_MODULE_17__["AllEffects"],
                _audit_audit_effects__WEBPACK_IMPORTED_MODULE_18__["AuditEffects"],
                _admin_admin_effects__WEBPACK_IMPORTED_MODULE_19__["AdminEffects"],
                _catalog_catalog_effects__WEBPACK_IMPORTED_MODULE_20__["CatalogEffects"],
                _transactions_transactions_effects__WEBPACK_IMPORTED_MODULE_21__["TransactionsEffects"],
                _wallet_wallet_effects__WEBPACK_IMPORTED_MODULE_22__["WalletEffects"],
                _shared_dialog_dialog_effects__WEBPACK_IMPORTED_MODULE_24__["DialogEffects"],
                _debug_debug_effects__WEBPACK_IMPORTED_MODULE_23__["DebugEffects"]
            ]),
            _angular_material__WEBPACK_IMPORTED_MODULE_15__["MatAutocompleteModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_15__["MatButtonModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_15__["MatButtonToggleModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_15__["MatCardModule"],
            // MatCheckboxModule,
            // MatChipsModule,
            _angular_material__WEBPACK_IMPORTED_MODULE_15__["MatTableModule"],
            // MatDatepickerModule,
            _angular_material__WEBPACK_IMPORTED_MODULE_15__["MatDialogModule"],
            // MatExpansionModule,
            _angular_material__WEBPACK_IMPORTED_MODULE_15__["MatFormFieldModule"],
            // MatGridListModule,
            _angular_material__WEBPACK_IMPORTED_MODULE_15__["MatIconModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_15__["MatInputModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_15__["MatListModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_15__["MatMenuModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_15__["MatPaginatorModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_15__["MatProgressBarModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_15__["MatProgressSpinnerModule"],
            // MatRadioModule,
            _angular_material__WEBPACK_IMPORTED_MODULE_15__["MatSelectModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_15__["MatSidenavModule"],
            // MatSlideToggleModule,
            // MatSliderModule,
            _angular_material__WEBPACK_IMPORTED_MODULE_15__["MatSnackBarModule"],
            // MatSortModule,
            // MatStepperModule,
            _angular_material__WEBPACK_IMPORTED_MODULE_15__["MatTabsModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_15__["MatToolbarModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_15__["MatTooltipModule"],
        ],
        providers: [],
        bootstrap: [_app_component__WEBPACK_IMPORTED_MODULE_6__["AppComponent"]],
        entryComponents: [
            _shared_dialog_dialog_component__WEBPACK_IMPORTED_MODULE_25__["DialogComponent"]
        ]
    })
], AppModule);



/***/ }),

/***/ "./src/app/app.reducer.ts":
/*!********************************!*\
  !*** ./src/app/app.reducer.ts ***!
  \********************************/
/*! exports provided: reducer */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reducer", function() { return reducer; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _environments_environment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../environments/environment */ "./src/environments/environment.ts");


const initialState = {
    user: {
        uid: null,
        email: null,
        displayName: null,
    },
    tezos: {
        // import node settings
        node: _environments_environment__WEBPACK_IMPORTED_MODULE_1__["environment"].tezos.nodes[_environments_environment__WEBPACK_IMPORTED_MODULE_1__["environment"].tezos.default],
        contract: _environments_environment__WEBPACK_IMPORTED_MODULE_1__["environment"].tezos.contract,
    },
    progressbar: {
        isVisible: false,
        counter: 0,
    },
    sidenav: {
        isVisible: true,
        color: 'white',
        toggleButton: {
            isVisible: true,
        },
    },
    toolbar: {
        isVisible: true,
        color: 'white',
    },
    menu: {
        isCatalog: false,
        isAudit: true,
        isTransactions: false,
        isAdmin: false,
    }
};
function reducer(state = initialState, action) {
    switch (action.type) {
        case 'WALLET_CHANGE': {
            switch (action.payload.role) {
                case 'auditor':
                    return Object.assign({}, state, { menu: {
                            isCatalog: false,
                            isAudit: true,
                            isTransactions: false,
                            isAdmin: false,
                        } });
                case 'admin':
                    return Object.assign({}, state, { menu: {
                            isCatalog: false,
                            isAudit: false,
                            isTransactions: false,
                            isAdmin: true,
                        } });
                default:
                    return Object.assign({}, state, { menu: {
                            isCatalog: true,
                            isAudit: false,
                            isTransactions: true,
                            isAdmin: false,
                        } });
            }
        }
        case 'WALLET_BUY_DATA':
        case 'WALLET_REQUEST_PUBLICATION':
        case 'WALLET_CREATE_DATA':
        case 'WALLET_CREATE_META_DATA':
        case 'WALLET_ALLOW_PUBLICATION': {
            return Object.assign({}, state, { progressbar: {
                    isVisible: state.progressbar.counter >= 0 ? true : false,
                    counter: state.progressbar.counter + 1
                } });
        }
        case 'WALLET_REQUEST_PUBLICATION_SUCCESS':
        case 'WALLET_ALLOW_PUBLICATION_SUCCESS':
        case 'WALLET_ALLOW_PUBLICATION_ERROR':
        case 'WALLET_REQUEST_PUBLICATION_ERROR':
        case 'WALLET_CREATE_DATA_SUCCESS':
        case 'WALLET_CREATE_META_DATA_SUCCESS':
        case 'WALLET_CREATE_DATA_ERROR':
        case 'WALLET_CREATE_META_DATA_ERROR':
        case 'WALLET_BUY_DATA_SUCCESS':
        case 'WALLET_BUY_DATA_ERROR': {
            return Object.assign({}, state, { progressbar: {
                    counter: state.progressbar.counter - 1,
                    isVisible: state.progressbar.counter === 1 ? false : true,
                } });
        }
        default:
            return state;
    }
}


/***/ }),

/***/ "./src/app/app.reducers.ts":
/*!*********************************!*\
  !*** ./src/app/app.reducers.ts ***!
  \*********************************/
/*! exports provided: reducers, logger, metaReducers */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reducers", function() { return reducers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "logger", function() { return logger; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "metaReducers", function() { return metaReducers; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var ngrx_store_logger__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ngrx-store-logger */ "./node_modules/ngrx-store-logger/dist/index.js");
/* harmony import */ var ngrx_store_logger__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(ngrx_store_logger__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _ngrx_router_store__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @ngrx/router-store */ "./node_modules/@ngrx/router-store/fesm2015/router-store.js");
/* harmony import */ var _environments_environment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../environments/environment */ "./src/environments/environment.ts");
/* harmony import */ var _app_reducer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./app.reducer */ "./src/app/app.reducer.ts");
/* harmony import */ var _admin_admin_reducer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./admin/admin.reducer */ "./src/app/admin/admin.reducer.ts");
/* harmony import */ var _audit_audit_reducer__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./audit/audit.reducer */ "./src/app/audit/audit.reducer.ts");
/* harmony import */ var _catalog_catalog_reducer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./catalog/catalog.reducer */ "./src/app/catalog/catalog.reducer.ts");
/* harmony import */ var _transactions_transactions_reducer__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./transactions/transactions.reducer */ "./src/app/transactions/transactions.reducer.ts");
/* harmony import */ var _wallet_wallet_reducer__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./wallet/wallet.reducer */ "./src/app/wallet/wallet.reducer.ts");
/* harmony import */ var _shared_dialog_dialog_reducer__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./shared/dialog/dialog.reducer */ "./src/app/shared/dialog/dialog.reducer.ts");




//   add remote error loging
//   import * as LogRocket from 'logrocket';
//   import createNgrxMiddleware from 'logrocket-ngrx';







// state
const reducers = {
    app: _app_reducer__WEBPACK_IMPORTED_MODULE_4__["reducer"],
    admin: _admin_admin_reducer__WEBPACK_IMPORTED_MODULE_5__["reducer"],
    audit: _audit_audit_reducer__WEBPACK_IMPORTED_MODULE_6__["reducer"],
    catalog: _catalog_catalog_reducer__WEBPACK_IMPORTED_MODULE_7__["reducer"],
    transactions: _transactions_transactions_reducer__WEBPACK_IMPORTED_MODULE_8__["reducer"],
    wallet: _wallet_wallet_reducer__WEBPACK_IMPORTED_MODULE_9__["reducer"],
    dialog: _shared_dialog_dialog_reducer__WEBPACK_IMPORTED_MODULE_10__["reducer"],
    routerReducer: _ngrx_router_store__WEBPACK_IMPORTED_MODULE_2__["routerReducer"],
};
// console.log all actions
function logger(reducer) {
    // default, no options
    return Object(ngrx_store_logger__WEBPACK_IMPORTED_MODULE_1__["storeLogger"])()(reducer);
}
//const logrocketMiddleware = createNgrxMiddleware(LogRocket);
// init metareducer
const metaReducers = !_environments_environment__WEBPACK_IMPORTED_MODULE_3__["environment"].production
    ? []
    : [logger];


/***/ }),

/***/ "./src/app/app.routing.ts":
/*!********************************!*\
  !*** ./src/app/app.routing.ts ***!
  \********************************/
/*! exports provided: AppRouting, CustomRouterStateSerializer */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppRouting", function() { return AppRouting; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CustomRouterStateSerializer", function() { return CustomRouterStateSerializer; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _admin_admin_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./admin/admin.component */ "./src/app/admin/admin.component.ts");
/* harmony import */ var _audit_audit_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./audit/audit.component */ "./src/app/audit/audit.component.ts");
/* harmony import */ var _catalog_catalog_component__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./catalog/catalog.component */ "./src/app/catalog/catalog.component.ts");
/* harmony import */ var _transactions_transactions_component__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./transactions/transactions.component */ "./src/app/transactions/transactions.component.ts");
/* harmony import */ var _create_create_component__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./create/create.component */ "./src/app/create/create.component.ts");
/* harmony import */ var _debug_debug_component__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./debug/debug.component */ "./src/app/debug/debug.component.ts");







const AppRouting = [
    { path: 'catalog', component: _catalog_catalog_component__WEBPACK_IMPORTED_MODULE_3__["CatalogComponent"] },
    { path: 'catalog/create', component: _create_create_component__WEBPACK_IMPORTED_MODULE_5__["CreateComponent"] },
    { path: 'transactions', component: _transactions_transactions_component__WEBPACK_IMPORTED_MODULE_4__["TransactionsComponent"] },
    { path: 'admin', component: _admin_admin_component__WEBPACK_IMPORTED_MODULE_1__["AdminComponent"] },
    { path: 'audit', component: _audit_audit_component__WEBPACK_IMPORTED_MODULE_2__["AuditComponent"] },
    { path: 'debug', component: _debug_debug_component__WEBPACK_IMPORTED_MODULE_6__["DebugComponent"] },
    { path: '', redirectTo: '/catalog', pathMatch: 'full' },
];
class CustomRouterStateSerializer {
    serialize(routerState) {
        const { url } = routerState;
        const queryParams = routerState.root.queryParams;
        return { url, queryParams };
    }
}


/***/ }),

/***/ "./src/app/audit/audit.component.css":
/*!*******************************************!*\
  !*** ./src/app/audit/audit.component.css ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("app-audit {\n  width: 100%;\n}\n\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvYXVkaXQvYXVkaXQuY29tcG9uZW50LmNzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLFdBQVc7QUFDYiIsImZpbGUiOiJzcmMvYXBwL2F1ZGl0L2F1ZGl0LmNvbXBvbmVudC5jc3MiLCJzb3VyY2VzQ29udGVudCI6WyJhcHAtYXVkaXQge1xuICB3aWR0aDogMTAwJTtcbn1cbiJdfQ== */");

/***/ }),

/***/ "./src/app/audit/audit.component.ts":
/*!******************************************!*\
  !*** ./src/app/audit/audit.component.ts ***!
  \******************************************/
/*! exports provided: AuditComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AuditComponent", function() { return AuditComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _ngrx_store__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @ngrx/store */ "./node_modules/@ngrx/store/fesm2015/store.js");
/* harmony import */ var _angular_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/material */ "./node_modules/@angular/material/esm2015/material.js");




let AuditComponent = class AuditComponent {
    constructor(store) {
        this.store = store;
    }
    ngOnInit() {
        // get audit data from smart contrat
        this.store.dispatch({
            type: 'AUDIT_LOAD',
        });
        // subscribe to app state
        this.store.select('audit')
            .subscribe(data => {
            this.audit = data.ids
                .filter(id => data.entities[id].params)
                .map(id => (Object.assign({ id }, data.entities[id])))
                .sort((a, b) => b.timestamp - a.timestamp);
            this.auditDataSource = new _angular_material__WEBPACK_IMPORTED_MODULE_3__["MatTableDataSource"](this.audit);
            this.auditDataSource.paginator = this.paginator;
        });
    }
};
AuditComponent.ctorParameters = () => [
    { type: _ngrx_store__WEBPACK_IMPORTED_MODULE_2__["Store"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])(_angular_material__WEBPACK_IMPORTED_MODULE_3__["MatPaginator"], { static: true })
], AuditComponent.prototype, "paginator", void 0);
AuditComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-audit',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./audit.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/audit/audit.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./audit.component.css */ "./src/app/audit/audit.component.css")).default]
    })
], AuditComponent);



/***/ }),

/***/ "./src/app/audit/audit.effects.ts":
/*!****************************************!*\
  !*** ./src/app/audit/audit.effects.ts ***!
  \****************************************/
/*! exports provided: AuditEffects */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AuditEffects", function() { return AuditEffects; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _ngrx_effects__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @ngrx/effects */ "./node_modules/@ngrx/effects/fesm2015/effects.js");
/* harmony import */ var _ngrx_store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @ngrx/store */ "./node_modules/@ngrx/store/fesm2015/store.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");







let AuditEffects = class AuditEffects {
    constructor(actions$, store, router, zone, http) {
        this.actions$ = actions$;
        this.store = store;
        this.router = router;
        this.zone = zone;
        this.http = http;
        // get audit trail from  explorer
        this.AuditLoadWallet$ = this.actions$.pipe(Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_2__["ofType"])('AUDIT_LOAD'), 
        // get state from store
        Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["withLatestFrom"])(this.store, (action, state) => ({ action, state })), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["flatMap"])(({ action, state }) => this.http.get(state.app.tezos.node.tzstats.api + '/tables/op?columns=hash,time,sender,has_data,parameters,status,height&receiver=' + state.app.tezos.contract.catalog.address)), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["map"])((response) => ({ type: 'AUDIT_LOAD_SUCCESS', payload: response })), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])((error, caught) => {
            console.error(error.message);
            this.store.dispatch({
                type: 'AUDIT_LOAD_ERROR',
                payload: error.message,
            });
            return caught;
        }));
    }
};
AuditEffects.ctorParameters = () => [
    { type: _ngrx_effects__WEBPACK_IMPORTED_MODULE_2__["Actions"] },
    { type: _ngrx_store__WEBPACK_IMPORTED_MODULE_3__["Store"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_4__["Router"] },
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["NgZone"] },
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_6__["HttpClient"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_2__["Effect"])()
], AuditEffects.prototype, "AuditLoadWallet$", void 0);
AuditEffects = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])()
], AuditEffects);



/***/ }),

/***/ "./src/app/audit/audit.reducer.ts":
/*!****************************************!*\
  !*** ./src/app/audit/audit.reducer.ts ***!
  \****************************************/
/*! exports provided: reducer, hex2string, getEntryPoint, getDataId */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reducer", function() { return reducer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hex2string", function() { return hex2string; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getEntryPoint", function() { return getEntryPoint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDataId", function() { return getDataId; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var moment_moment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! moment/moment */ "./node_modules/moment/moment.js");
/* harmony import */ var moment_moment__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(moment_moment__WEBPACK_IMPORTED_MODULE_1__);


const initialState = {
    ids: [],
    entities: {},
    page: 0,
    itemsPerPage: 10,
    itemsTotalCount: 0
};
function reducer(state = initialState, action) {
    switch (action.type) {
        case 'AUDIT_LOAD_SUCCESS': {
            // debugger
            return Object.assign({}, state, { ids: [
                    ...action.payload.map(operations => operations[0])
                ], entities: action.payload.reduce((accumulator, operation) => {
                    // convert date time to moment
                    const momentDateTime = moment_moment__WEBPACK_IMPORTED_MODULE_1__(operation[1]);
                    return Object.assign({}, accumulator, { 
                        // hash,time,sender,has_data,parameters,status,height
                        [operation[0]]: {
                            hash: operation[0],
                            timestamp: operation[1],
                            time: momentDateTime.format('DD MMM YYYY, HH:mm'),
                            sender: operation[2],
                            has_data: operation[3],
                            params: getEntryPoint(operation[4]),
                            data_id: getDataId(operation[4]),
                            status: operation[5],
                            height: operation[6]
                        } });
                }, {}) });
        }
        default:
            return state;
    }
}
// convert hex to string
function hex2string(input) {
    // if empty return
    if (!input)
        return '';
    var hex = input.toString();
    var str = '';
    for (var i = 0; (i < hex.length && hex.substr(i, 2) !== '00'); i += 2)
        str += String.fromCharCode(parseInt(hex.substr(i, 2), 16));
    return str;
}
// convert params for entry point call
function getEntryPoint(input) {
    if (!input)
        return '';
    const entryPointNameSize = parseInt(input.substr(4, 2), 16);
    const entryPointName = input.substr(6, entryPointNameSize * 2);
    return hex2string(entryPointName);
}
function getDataId(input) {
    const entryPointName = getEntryPoint(input);
    const entryPointNameSize = entryPointName.length;
    switch (entryPointName) {
        case 'createData':
        case 'allowDataPublication': {
            const getDataIdPointer = 6 + (entryPointNameSize * 2) + 18;
            const getDataIdSize = parseInt(input.substr(getDataIdPointer, 2), 16);
            return hex2string(input.substr(getDataIdPointer, getDataIdSize * 2));
        }
        case 'createMetaData': {
            const getDataIdPointer = 6 + (entryPointNameSize * 2) + 18;
            const getDataIdSize = parseInt(input.substr(getDataIdPointer, 2), 16);
            // console.log(
            //     getDataIdPointer,
            //     getDataIdSize,
            //     hex2string(input.substr(getDataIdPointer, getDataIdSize * 2)),
            //     input.substr(getDataIdPointer, getDataIdSize * 2),
            //     input
            // );
            return hex2string(input.substr(getDataIdPointer, getDataIdSize * 2));
        }
        case 'buyData': {
            const getDataIdPointer = 6 + (entryPointNameSize * 2) + 24;
            const getDataIdSize = parseInt(input.substr(getDataIdPointer, 2), 16);
            return hex2string(input.substr(getDataIdPointer + 2, getDataIdSize * 2));
        }
        case 'requestDataPublication': {
            const getDataIdPointer = 6 + (entryPointNameSize * 2) + 22;
            const getDataIdSize = parseInt(input.substr(getDataIdPointer, 2), 16);
            return hex2string(input.substr(getDataIdPointer, getDataIdSize * 2));
        }
        default:
            return '';
    }
}


/***/ }),

/***/ "./src/app/catalog/catalog.component.css":
/*!***********************************************!*\
  !*** ./src/app/catalog/catalog.component.css ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2NhdGFsb2cvY2F0YWxvZy5jb21wb25lbnQuY3NzIn0= */");

/***/ }),

/***/ "./src/app/catalog/catalog.component.ts":
/*!**********************************************!*\
  !*** ./src/app/catalog/catalog.component.ts ***!
  \**********************************************/
/*! exports provided: CatalogComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CatalogComponent", function() { return CatalogComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _ngrx_store__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @ngrx/store */ "./node_modules/@ngrx/store/fesm2015/store.js");
/* harmony import */ var _angular_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/material */ "./node_modules/@angular/material/esm2015/material.js");




let CatalogComponent = class CatalogComponent {
    constructor(store) {
        this.store = store;
    }
    ngOnInit() {
        // get catalog data from smart contrat
        this.store.dispatch({
            type: 'CATALOG_LOAD',
        });
        // subscribe to app state
        this.store.select('catalog')
            .subscribe(data => {
            this.catalog = data.ids.map(id => (Object.assign({ id }, data.entities[id])));
            this.catalogDataSource = new _angular_material__WEBPACK_IMPORTED_MODULE_3__["MatTableDataSource"](this.catalog);
            this.catalogDataSource.paginator = this.paginator;
            this.actions = data.actions;
        });
    }
    allowPublication(data_id) {
        console.log('[WALLET_ALLOW_PUBLICATION]', data_id);
        // allow publication
        this.store.dispatch({
            type: 'WALLET_ALLOW_PUBLICATION',
            payload: {
                data_id: data_id,
            }
        });
    }
    requestPublication(data_id) {
        console.log('[WALLET_REQUEST_PUBLICATION]', data_id);
        // request publication
        this.store.dispatch({
            type: 'WALLET_REQUEST_PUBLICATION',
            payload: {
                data_id: data_id,
            }
        });
    }
    buyData(data_id) {
        console.log('[WALLET_BUY_DATA]', data_id);
        // request buy data
        this.store.dispatch({
            type: 'WALLET_BUY_DATA',
            payload: {
                data_id: data_id,
            }
        });
    }
    createData() {
        console.log('[WALLET_CREATE_DATA]');
        // request create data
        this.store.dispatch({
            type: 'WALLET_CREATE_DATA',
        });
    }
};
CatalogComponent.ctorParameters = () => [
    { type: _ngrx_store__WEBPACK_IMPORTED_MODULE_2__["Store"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])(_angular_material__WEBPACK_IMPORTED_MODULE_3__["MatPaginator"], { static: true })
], CatalogComponent.prototype, "paginator", void 0);
CatalogComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-catalog',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./catalog.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/catalog/catalog.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./catalog.component.css */ "./src/app/catalog/catalog.component.css")).default]
    })
], CatalogComponent);



/***/ }),

/***/ "./src/app/catalog/catalog.effects.ts":
/*!********************************************!*\
  !*** ./src/app/catalog/catalog.effects.ts ***!
  \********************************************/
/*! exports provided: CatalogEffects */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CatalogEffects", function() { return CatalogEffects; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _ngrx_effects__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @ngrx/effects */ "./node_modules/@ngrx/effects/fesm2015/effects.js");
/* harmony import */ var _ngrx_store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @ngrx/store */ "./node_modules/@ngrx/store/fesm2015/store.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");







let CatalogEffects = class CatalogEffects {
    constructor(actions$, store, router, zone, http) {
        this.actions$ = actions$;
        this.store = store;
        this.router = router;
        this.zone = zone;
        this.http = http;
        // get catalog data from users big map
        this.CatalogLoadWallet$ = this.actions$.pipe(Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_2__["ofType"])('CATALOG_LOAD'), 
        // get state from store
        Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["withLatestFrom"])(this.store, (action, state) => ({ action, state })), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["flatMap"])(({ action, state }) => 
        // this.http.get(state.app.tezos.node.url + '/chains/main/blocks/head/context/raw/json/big_maps/index/628/contents/?depth=5')
        this.http.get(state.app.tezos.node.url + '/chains/main/blocks/head/context/raw/json/big_maps/index/653/contents/?depth=5')), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["map"])((response) => ({ type: 'CATALOG_LOAD_SUCCESS', payload: response })), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["catchError"])((error, caught) => {
            console.error(error.message);
            this.store.dispatch({
                type: 'CATALOG_LOAD_ERROR',
                payload: error.message,
            });
            return caught;
        }));
    }
};
CatalogEffects.ctorParameters = () => [
    { type: _ngrx_effects__WEBPACK_IMPORTED_MODULE_2__["Actions"] },
    { type: _ngrx_store__WEBPACK_IMPORTED_MODULE_3__["Store"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_4__["Router"] },
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["NgZone"] },
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_6__["HttpClient"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_2__["Effect"])()
], CatalogEffects.prototype, "CatalogLoadWallet$", void 0);
CatalogEffects = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])()
], CatalogEffects);



/***/ }),

/***/ "./src/app/catalog/catalog.reducer.ts":
/*!********************************************!*\
  !*** ./src/app/catalog/catalog.reducer.ts ***!
  \********************************************/
/*! exports provided: reducer */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reducer", function() { return reducer; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

const initialState = {
    ids: [],
    entities: {},
    page: 0,
    itemsPerPage: 10,
    itemsTotalCount: 0,
    actions: {
        isRequestPublish: false,
        isPublish: false,
        isBuy: false,
    }
};
function reducer(state = initialState, action) {
    switch (action.type) {
        case 'CATALOG_LOAD_SUCCESS': {
            return Object.assign({}, state, { ids: [
                    ...action.payload.map(catalog => catalog[0])
                ], entities: action.payload.reduce((accumulator, catalog) => {
                    return Object.assign({}, accumulator, { [catalog[0]]: {
                            data_creator: catalog[1].args[0].args[0].args[0].bytes,
                            data_id: catalog[1].args[0].args[0].args[1].string,
                            data_publisher: catalog[1].args[0].args[1].args[0].prim,
                            is_data_public: catalog[1].args[0].args[1].args[1].string,
                            meta_data_id: catalog[1].args[1].args[1].prim !== "Some" ?
                                catalog[1].args[1].args[1].prim :
                                catalog[1].args[1].args[1].args[0].string,
                            keywords: catalog[1].args[1].args[0].string,
                        } });
                }, {}) });
        }
        case 'WALLET_CHANGE': {
            switch (action.payload.role) {
                case 'customer':
                    return Object.assign({}, state, { actions: {
                            isRequestPublish: false,
                            isPublish: false,
                            isBuy: true,
                            isCreateData: false,
                            isCreateMetaData: false,
                        } });
                case 'creator':
                    return Object.assign({}, state, { actions: {
                            isRequestPublish: true,
                            isPublish: false,
                            isBuy: false,
                            isCreateData: true,
                            isCreateMetaData: false,
                        } });
                case 'meta_creator':
                    return Object.assign({}, state, { actions: {
                            isRequestPublish: true,
                            isPublish: false,
                            isBuy: false,
                            isCreateData: false,
                            isCreateMetaData: true,
                        } });
                case 'publisher':
                    return Object.assign({}, state, { actions: {
                            isRequestPublish: false,
                            isPublish: true,
                            isBuy: false,
                            isCreateData: false,
                            isCreateMetaData: false,
                        } });
                case 'admin':
                case 'auditor':
                    return Object.assign({}, state, { actions: {
                            isRequestPublish: false,
                            isPublish: false,
                            isBuy: false,
                            isCreateData: false,
                            isCreateMetaData: false,
                        } });
                default:
                    return Object.assign({}, state, { actions: {
                            isRequestPublish: false,
                            isPublish: false,
                            isBuy: false,
                            isCreateData: false,
                            isCreateMetaData: false,
                        } });
            }
        }
        default:
            return state;
    }
}


/***/ }),

/***/ "./src/app/create/create.component.css":
/*!*********************************************!*\
  !*** ./src/app/create/create.component.css ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2NyZWF0ZS9jcmVhdGUuY29tcG9uZW50LmNzcyJ9 */");

/***/ }),

/***/ "./src/app/create/create.component.ts":
/*!********************************************!*\
  !*** ./src/app/create/create.component.ts ***!
  \********************************************/
/*! exports provided: CreateComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CreateComponent", function() { return CreateComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _ngrx_store__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @ngrx/store */ "./node_modules/@ngrx/store/fesm2015/store.js");



let CreateComponent = class CreateComponent {
    constructor(store) {
        this.store = store;
    }
    ngOnInit() {
        // subscribe to app state
        this.store.select('wallet')
            .subscribe(data => {
            this.wallet = data;
        });
    }
    createData() {
        console.log('[createData]', this.data_id, this.meta_data_id, this.keywords);
        if (this.data_id) {
            this.store.dispatch({
                type: 'WALLET_CREATE_DATA',
                payload: {
                    data_id: this.data_id,
                    keywords: this.keywords,
                    role: this.wallet.selected.role,
                }
            });
        }
    }
    createMetaData() {
        console.log('[createMetaData]', this.data_id, this.meta_data_id, this.keywords);
        if (this.data_id) {
            this.store.dispatch({
                type: 'WALLET_CREATE_META_DATA',
                payload: {
                    data_id: this.data_id,
                    meta_data_id: this.meta_data_id,
                    keywords: this.keywords,
                    role: this.wallet.selected.role,
                }
            });
        }
    }
};
CreateComponent.ctorParameters = () => [
    { type: _ngrx_store__WEBPACK_IMPORTED_MODULE_2__["Store"] }
];
CreateComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-create',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./create.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/create/create.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./create.component.css */ "./src/app/create/create.component.css")).default]
    })
], CreateComponent);



/***/ }),

/***/ "./src/app/debug/debug.component.css":
/*!*******************************************!*\
  !*** ./src/app/debug/debug.component.css ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2RlYnVnL2RlYnVnLmNvbXBvbmVudC5jc3MifQ== */");

/***/ }),

/***/ "./src/app/debug/debug.component.ts":
/*!******************************************!*\
  !*** ./src/app/debug/debug.component.ts ***!
  \******************************************/
/*! exports provided: DebugComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DebugComponent", function() { return DebugComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _ngrx_store__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @ngrx/store */ "./node_modules/@ngrx/store/fesm2015/store.js");



let DebugComponent = class DebugComponent {
    constructor(store) {
        this.store = store;
    }
    ngOnInit() {
    }
    sendTransaction() {
        // dispatch action for send transaction
        this.store.dispatch({
            type: 'TEZOS_SEND_TRANSACTION'
        });
    }
};
DebugComponent.ctorParameters = () => [
    { type: _ngrx_store__WEBPACK_IMPORTED_MODULE_2__["Store"] }
];
DebugComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-debug',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./debug.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/debug/debug.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./debug.component.css */ "./src/app/debug/debug.component.css")).default]
    })
], DebugComponent);



/***/ }),

/***/ "./src/app/debug/debug.effects.ts":
/*!****************************************!*\
  !*** ./src/app/debug/debug.effects.ts ***!
  \****************************************/
/*! exports provided: DebugEffects */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DebugEffects", function() { return DebugEffects; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _ngrx_effects__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @ngrx/effects */ "./node_modules/@ngrx/effects/fesm2015/effects.js");
/* harmony import */ var _ngrx_store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @ngrx/store */ "./node_modules/@ngrx/store/fesm2015/store.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var _shared_utils_rxjs_operators__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../shared/utils/rxjs/operators */ "./src/app/shared/utils/rxjs/operators.ts");
/* harmony import */ var tezos_wallet__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! tezos-wallet */ "./node_modules/tezos-wallet/lib/index.js");









const wallet = {
    secretKey: 'edsk3hEtniBGLP2wqYnc1Lix1hhV74eEenRBTfxjHTRHP59R7BapMW',
    publicKey: 'edpkth42B7j7rvLeZWmufj28a7sEdbMBb9y16qgQmGHYGX4hPis9V4',
    publicKeyHash: 'tz1WCojrEZWrjenejUZmG8QNsMtKPELx2TFA',
    node: {
        name: 'babylon',
        display: 'Babylon',
        url: 'https://alphanet.simplestaking.com:3000',
        tzstats: {
            url: 'http://babylonnet.tzstats.com/account/',
        }
    },
    type: 'web'
};
let DebugEffects = class DebugEffects {
    constructor(actions$, store, router, zone) {
        this.actions$ = actions$;
        this.store = store;
        this.router = router;
        this.zone = zone;
        this.TezosSendTransaction$ = this.actions$.pipe(Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_2__["ofType"])('TEZOS_SEND_TRANSACTION'), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_6__["withLatestFrom"])(this.store, (action, state) => ({ action, state })), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_6__["flatMap"])(({ action, state }) => Object(rxjs__WEBPACK_IMPORTED_MODULE_5__["of"])([]).pipe(
        // wait until sodium is ready
        Object(tezos_wallet__WEBPACK_IMPORTED_MODULE_8__["initializeWallet"])(stateWallet => ({
            secretKey: wallet.secretKey,
            publicKey: wallet.publicKey,
            // for smart contract use manager address
            publicKeyHash: wallet.publicKeyHash,
            // set tezos node
            node: wallet.node,
            type: wallet.type,
        })), 
        // tz-stats
        // https://api.babylonnet.tzstats.com/tables/op?columns=row_id,time,status,hash,sender,big_map_diff&receiver=KT1Ueoy8N2k45A5JVS5SSRNAA6oP4hweHR3o
        // contract
        // https://alphanet.simplestaking.com:3000/chains/main/blocks/head/context/contracts/KT1Ueoy8N2k45A5JVS5SSRNAA6oP4hweHR3o
        // transfer tokens
        Object(tezos_wallet__WEBPACK_IMPORTED_MODULE_8__["transaction"])(stateWallet => ({
            to: state.app.tezos.contract.catalog.address,
            amount: '0',
            fee: '0.1',
            parameters: {
                "entrypoint": "setRole",
                "value": {
                    "prim": "Pair",
                    "args": [{
                            "prim": "Pair",
                            "args": [{
                                    "prim": "Pair",
                                    "args": [{ "prim": "False" },
                                        { "prim": "False" }]
                                },
                                {
                                    "prim": "Pair",
                                    "args": [{ "prim": "False" },
                                        { "prim": "False" }]
                                }]
                        },
                        { "string": "tz1MGtVUsRN2duS21pLgSUuAhuW1hhQmLXKP" }]
                }
            },
        })), 
        // wait until operation is confirmed & moved from mempool to head
        Object(tezos_wallet__WEBPACK_IMPORTED_MODULE_8__["confirmOperation"])(stateWallet => ({
            injectionOperation: stateWallet.injectionOperation,
        })), 
        // enter back into zone.js so change detection works
        Object(_shared_utils_rxjs_operators__WEBPACK_IMPORTED_MODULE_7__["enterZone"])(this.zone))), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_6__["map"])(action => ({ type: 'TEZOS_SEND_TRANSACTION_SUCCESS', payload: action })), 
        // dispatch error action
        Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_6__["catchError"])((error, caught) => {
            console.error(error);
            this.store.dispatch({
                type: 'TEZOS_SEND_TRANSACTION_ERROR', payload: error.response,
            });
            return caught;
        }));
    }
};
DebugEffects.ctorParameters = () => [
    { type: _ngrx_effects__WEBPACK_IMPORTED_MODULE_2__["Actions"] },
    { type: _ngrx_store__WEBPACK_IMPORTED_MODULE_3__["Store"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_4__["Router"] },
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["NgZone"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_2__["Effect"])()
], DebugEffects.prototype, "TezosSendTransaction$", void 0);
DebugEffects = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])()
], DebugEffects);



/***/ }),

/***/ "./src/app/shared/dialog/dialog.component.css":
/*!****************************************************!*\
  !*** ./src/app/shared/dialog/dialog.component.css ***!
  \****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3NoYXJlZC9kaWFsb2cvZGlhbG9nLmNvbXBvbmVudC5jc3MifQ== */");

/***/ }),

/***/ "./src/app/shared/dialog/dialog.component.ts":
/*!***************************************************!*\
  !*** ./src/app/shared/dialog/dialog.component.ts ***!
  \***************************************************/
/*! exports provided: DialogComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DialogComponent", function() { return DialogComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/material */ "./node_modules/@angular/material/esm2015/material.js");
/* harmony import */ var _ngrx_store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @ngrx/store */ "./node_modules/@ngrx/store/fesm2015/store.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");






let DialogComponent = class DialogComponent {
    constructor(dialogRef, store) {
        this.dialogRef = dialogRef;
        this.store = store;
        this.destroy$ = new rxjs__WEBPACK_IMPORTED_MODULE_4__["Subject"]();
    }
    ngOnInit() {
        // listen for redux data  
        this.store.select('dialog')
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["takeUntil"])(this.destroy$))
            .subscribe(state => {
            this.dialog = state;
        });
    }
    closeDialog() {
        this.dialogRef.close();
    }
    ngOnDestroy() {
        this.store.dispatch({
            type: 'DIALOG_DESTROY',
        });
        // close all observables
        this.destroy$.next();
        this.destroy$.complete();
    }
};
DialogComponent.ctorParameters = () => [
    { type: _angular_material__WEBPACK_IMPORTED_MODULE_2__["MatDialogRef"] },
    { type: _ngrx_store__WEBPACK_IMPORTED_MODULE_3__["Store"] }
];
DialogComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-dialog',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./dialog.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/dialog/dialog.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./dialog.component.css */ "./src/app/shared/dialog/dialog.component.css")).default]
    })
], DialogComponent);



/***/ }),

/***/ "./src/app/shared/dialog/dialog.effects.ts":
/*!*************************************************!*\
  !*** ./src/app/shared/dialog/dialog.effects.ts ***!
  \*************************************************/
/*! exports provided: DialogEffects */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DialogEffects", function() { return DialogEffects; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _ngrx_store__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @ngrx/store */ "./node_modules/@ngrx/store/fesm2015/store.js");
/* harmony import */ var _ngrx_effects__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @ngrx/effects */ "./node_modules/@ngrx/effects/fesm2015/effects.js");
/* harmony import */ var _angular_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/material */ "./node_modules/@angular/material/esm2015/material.js");
/* harmony import */ var _shared_dialog_dialog_component__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../shared/dialog/dialog.component */ "./src/app/shared/dialog/dialog.component.ts");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");







let DialogEffects = class DialogEffects {
    constructor(actions$, store, dialog) {
        this.actions$ = actions$;
        this.store = store;
        this.dialog = dialog;
        // trigger data load based on navigation change  
        this.DialogWarning$ = this.actions$.pipe(Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_3__["ofType"])('TEZOS_SEND_TRANSACTION_ERROR', 'WALLET_REQUEST_PUBLICATION_ERROR', 'WALLET_ALLOW_PUBLICATION_ERROR', 'WALLET_BUY_DATA_ERROR', 'WALLET_CREATE_DATA_ERROR', 'WALLET_CREATE_META_DATA_ERROR'), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_6__["map"])((action) => ({ type: 'DIALOG_SHOW', payload: action.payload })), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_6__["catchError"])((error, caught) => {
            console.error(error.message);
            this.store.dispatch({
                type: 'DIALOG_SHOW',
                payload: error.message,
            });
            return caught;
        }));
        this.DialogWarningShow$ = this.actions$.pipe(Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_3__["ofType"])('DIALOG_SHOW'), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_6__["tap"])((action) => {
            this.dialog.open(_shared_dialog_dialog_component__WEBPACK_IMPORTED_MODULE_5__["DialogComponent"], {
                disableClose: true,
                autoFocus: false,
            });
        }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_6__["map"])(() => ({ type: 'DIALOG_SHOW_SUCCESS' })), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_6__["catchError"])((error, caught) => {
            console.error(error.message);
            this.store.dispatch({
                type: 'DETAIL_SHOW_ERROR',
                payload: error.message,
            });
            return caught;
        }));
    }
};
DialogEffects.ctorParameters = () => [
    { type: _ngrx_effects__WEBPACK_IMPORTED_MODULE_3__["Actions"] },
    { type: _ngrx_store__WEBPACK_IMPORTED_MODULE_2__["Store"] },
    { type: _angular_material__WEBPACK_IMPORTED_MODULE_4__["MatDialog"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_3__["Effect"])()
], DialogEffects.prototype, "DialogWarning$", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_3__["Effect"])()
], DialogEffects.prototype, "DialogWarningShow$", void 0);
DialogEffects = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])()
], DialogEffects);



/***/ }),

/***/ "./src/app/shared/dialog/dialog.reducer.ts":
/*!*************************************************!*\
  !*** ./src/app/shared/dialog/dialog.reducer.ts ***!
  \*************************************************/
/*! exports provided: reducer */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reducer", function() { return reducer; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

const initialState = {
    headline: '',
    content: '',
};
function reducer(state = initialState, action) {
    switch (action.type) {
        // TODO:  refactor errors  handling
        case 'DIALOG_SHOW': {
            const type = action.payload && action.payload.type ? action.payload.type : '';
            switch (type) {
                default:
                    return {
                        type: 'WARNING',
                        headline: 'Warning',
                        content: action.payload ? action.payload.map(line => ([
                            Object.keys(line).map(key => ({ name: key, value: line[key] }))
                        ])) : '',
                    };
            }
        }
        case 'DIALOG_DESTROY': {
            return Object.assign({}, initialState);
        }
        default:
            return state;
    }
}


/***/ }),

/***/ "./src/app/shared/svg-icon/svg-icon.component.css":
/*!********************************************************!*\
  !*** ./src/app/shared/svg-icon/svg-icon.component.css ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3NoYXJlZC9zdmctaWNvbi9zdmctaWNvbi5jb21wb25lbnQuY3NzIn0= */");

/***/ }),

/***/ "./src/app/shared/svg-icon/svg-icon.component.ts":
/*!*******************************************************!*\
  !*** ./src/app/shared/svg-icon/svg-icon.component.ts ***!
  \*******************************************************/
/*! exports provided: SvgIconComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SvgIconComponent", function() { return SvgIconComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let SvgIconComponent = class SvgIconComponent {
    constructor() {
        this.scale = 1;
    }
    ngOnInit() {
    }
};
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], SvgIconComponent.prototype, "icon", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], SvgIconComponent.prototype, "scale", void 0);
SvgIconComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'svg-icon',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./svg-icon.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/svg-icon/svg-icon.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./svg-icon.component.css */ "./src/app/shared/svg-icon/svg-icon.component.css")).default]
    })
], SvgIconComponent);



/***/ }),

/***/ "./src/app/shared/utils/rxjs/operators.ts":
/*!************************************************!*\
  !*** ./src/app/shared/utils/rxjs/operators.ts ***!
  \************************************************/
/*! exports provided: enterZone */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "enterZone", function() { return enterZone; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");


function enterZone(zone) {
    return function enterZoneImplementation(source) {
        return rxjs__WEBPACK_IMPORTED_MODULE_1__["Observable"].create(observer => {
            const onNext = (value) => zone.run(() => observer.next(value));
            const onError = (e) => zone.run(() => observer.error(e));
            const onComplete = () => zone.run(() => observer.complete());
            return source.subscribe(onNext, onError, onComplete);
        });
    };
}


/***/ }),

/***/ "./src/app/transactions/transactions.component.css":
/*!*********************************************************!*\
  !*** ./src/app/transactions/transactions.component.css ***!
  \*********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3RyYW5zYWN0aW9ucy90cmFuc2FjdGlvbnMuY29tcG9uZW50LmNzcyJ9 */");

/***/ }),

/***/ "./src/app/transactions/transactions.component.ts":
/*!********************************************************!*\
  !*** ./src/app/transactions/transactions.component.ts ***!
  \********************************************************/
/*! exports provided: TransactionsComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TransactionsComponent", function() { return TransactionsComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _ngrx_store__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @ngrx/store */ "./node_modules/@ngrx/store/fesm2015/store.js");
/* harmony import */ var _angular_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/material */ "./node_modules/@angular/material/esm2015/material.js");




let TransactionsComponent = class TransactionsComponent {
    constructor(store) {
        this.store = store;
    }
    ngOnInit() {
        // get catalog data from smart contrat
        this.store.dispatch({
            type: 'TRANSACTIONS_LOAD',
        });
        // subscribe to app state
        this.store.select('transactions')
            .subscribe(data => {
            this.transactions = data.ids.map(id => (Object.assign({ id }, data.entities[id])));
            this.transactionsDataSource = new _angular_material__WEBPACK_IMPORTED_MODULE_3__["MatTableDataSource"](this.transactions);
            this.transactionsDataSource.paginator = this.paginator;
        });
    }
};
TransactionsComponent.ctorParameters = () => [
    { type: _ngrx_store__WEBPACK_IMPORTED_MODULE_2__["Store"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])(_angular_material__WEBPACK_IMPORTED_MODULE_3__["MatPaginator"], { static: true })
], TransactionsComponent.prototype, "paginator", void 0);
TransactionsComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-transactions',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./transactions.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/transactions/transactions.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./transactions.component.css */ "./src/app/transactions/transactions.component.css")).default]
    })
], TransactionsComponent);



/***/ }),

/***/ "./src/app/transactions/transactions.effects.ts":
/*!******************************************************!*\
  !*** ./src/app/transactions/transactions.effects.ts ***!
  \******************************************************/
/*! exports provided: TransactionsEffects */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TransactionsEffects", function() { return TransactionsEffects; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _ngrx_effects__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @ngrx/effects */ "./node_modules/@ngrx/effects/fesm2015/effects.js");
/* harmony import */ var _ngrx_store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @ngrx/store */ "./node_modules/@ngrx/store/fesm2015/store.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");







let TransactionsEffects = class TransactionsEffects {
    constructor(actions$, store, router, http, zone) {
        this.actions$ = actions$;
        this.store = store;
        this.router = router;
        this.http = http;
        this.zone = zone;
        // get transactions data from users big map
        this.TransactionsLoadWallet$ = this.actions$.pipe(Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_2__["ofType"])('TRANSACTIONS_LOAD'), 
        // get state from store
        Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_6__["withLatestFrom"])(this.store, (action, state) => ({ action, state })), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_6__["flatMap"])(({ action, state }) => 
        // this.http.get(state.app.tezos.node.url + '/chains/main/blocks/head/context/raw/json/big_maps/index/629/contents/?depth=5')
        this.http.get(state.app.tezos.node.url + '/chains/main/blocks/head/context/raw/json/big_maps/index/654/contents/?depth=5')), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_6__["map"])((response) => ({ type: 'TRANSACTIONS_LOAD_SUCCESS', payload: response })), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_6__["catchError"])((error, caught) => {
            console.error(error.message);
            this.store.dispatch({
                type: 'TRANSACTIONS_LOAD_ERROR',
                payload: error.message,
            });
            return caught;
        }));
    }
};
TransactionsEffects.ctorParameters = () => [
    { type: _ngrx_effects__WEBPACK_IMPORTED_MODULE_2__["Actions"] },
    { type: _ngrx_store__WEBPACK_IMPORTED_MODULE_3__["Store"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_4__["Router"] },
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_5__["HttpClient"] },
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["NgZone"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_2__["Effect"])()
], TransactionsEffects.prototype, "TransactionsLoadWallet$", void 0);
TransactionsEffects = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])()
], TransactionsEffects);



/***/ }),

/***/ "./src/app/transactions/transactions.reducer.ts":
/*!******************************************************!*\
  !*** ./src/app/transactions/transactions.reducer.ts ***!
  \******************************************************/
/*! exports provided: reducer */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reducer", function() { return reducer; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

const initialState = {
    ids: [],
    entities: {},
    page: 0,
    itemsPerPage: 10,
    itemsTotalCount: 0
};
function reducer(state = initialState, action) {
    switch (action.type) {
        case 'TRANSACTIONS_LOAD_SUCCESS': {
            return {
                ids: [
                    ...action.payload.map(transactions => transactions[0])
                ],
                entities: action.payload.reduce((accumulator, transaction) => {
                    return Object.assign({}, accumulator, { [transaction[0]]: {
                            transaction_id: transaction[1].args[0].args[0].bytes,
                            data_id: transaction[1].args[0].args[1].string,
                            customer: transaction[1].args[1].args[0].string,
                            signature: transaction[1].args[1].args[1].string,
                        } });
                }, {}),
            };
        }
        default:
            return state;
    }
}


/***/ }),

/***/ "./src/app/wallet/wallet.component.css":
/*!*********************************************!*\
  !*** ./src/app/wallet/wallet.component.css ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3dhbGxldC93YWxsZXQuY29tcG9uZW50LmNzcyJ9 */");

/***/ }),

/***/ "./src/app/wallet/wallet.component.ts":
/*!********************************************!*\
  !*** ./src/app/wallet/wallet.component.ts ***!
  \********************************************/
/*! exports provided: WalletComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WalletComponent", function() { return WalletComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _ngrx_store__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @ngrx/store */ "./node_modules/@ngrx/store/fesm2015/store.js");



let WalletComponent = class WalletComponent {
    constructor(store) {
        this.store = store;
    }
    ngOnInit() {
        // subscribe to app state
        this.store.select('wallet')
            .subscribe(data => {
            this.wallets = data.ids.map(id => (Object.assign({ id }, data.entities[id])));
            this.wallet = data.selected;
        });
    }
    walletChange(wallet) {
        this.store.dispatch({
            type: 'WALLET_CHANGE',
            payload: wallet
        });
    }
};
WalletComponent.ctorParameters = () => [
    { type: _ngrx_store__WEBPACK_IMPORTED_MODULE_2__["Store"] }
];
WalletComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-wallet',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./wallet.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/wallet/wallet.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./wallet.component.css */ "./src/app/wallet/wallet.component.css")).default]
    })
], WalletComponent);



/***/ }),

/***/ "./src/app/wallet/wallet.effects.ts":
/*!******************************************!*\
  !*** ./src/app/wallet/wallet.effects.ts ***!
  \******************************************/
/*! exports provided: WalletEffects */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WalletEffects", function() { return WalletEffects; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _ngrx_effects__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @ngrx/effects */ "./node_modules/@ngrx/effects/fesm2015/effects.js");
/* harmony import */ var _ngrx_store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @ngrx/store */ "./node_modules/@ngrx/store/fesm2015/store.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var _shared_utils_rxjs_operators__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../shared/utils/rxjs/operators */ "./src/app/shared/utils/rxjs/operators.ts");
/* harmony import */ var tezos_wallet__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! tezos-wallet */ "./node_modules/tezos-wallet/lib/index.js");










let WalletEffects = class WalletEffects {
    constructor(actions$, store, router, http, zone) {
        this.actions$ = actions$;
        this.store = store;
        this.router = router;
        this.http = http;
        this.zone = zone;
        // redirect
        this.WalletRedirect$ = this.actions$.pipe(Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_2__["ofType"])('WALLET_CREATE_META_DATA_SUCCESS', 'WALLET_CREATE_DATA_SUCCESS', 'WALLET_CREATE_DATA_ERROR', 'WALLET_CREATE_META_DATA_ERROR', 'WALLET_REQUEST_PUBLICATION_SUCCESS', 'WALLET_ALLOW_PUBLICATION_SUCCESS', 'WALLET_ALLOW_PUBLICATION_ERROR', 'WALLET_REQUEST_PUBLICATION_ERROR'), 
        // redirect
        Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_7__["tap"])(() => {
            return this.router.navigate(['/catalog']);
        }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_7__["map"])(() => ({ type: 'CATALOG_LOAD' })), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_7__["catchError"])((error, caught) => {
            console.error(error.message);
            this.store.dispatch({
                type: 'REDIRECT_ERROR',
                payload: error.message,
            });
            return caught;
        }));
        // redirect
        this.WalletBuyDataRedirect$ = this.actions$.pipe(Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_2__["ofType"])('WALLET_BUY_DATA_ERROR', 'WALLET_BUY_DATA_SUCCESS'), 
        // redirect
        Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_7__["tap"])(({ action, state }) => {
            return this.router.navigate(['/transactions']);
        }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_7__["map"])(() => ({ type: 'TRANSACTIONS_LOAD' })), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_7__["catchError"])((error, caught) => {
            console.error(error.message);
            this.store.dispatch({
                type: 'REDIRECT_ERROR',
                payload: error.message,
            });
            return caught;
        }));
        // change user and redirect
        this.WalletChange$ = this.actions$.pipe(Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_2__["ofType"])('WALLET_CHANGE'), 
        // get state from store
        Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_7__["withLatestFrom"])(this.store, (action, state) => ({ action, state })), 
        // redirect
        Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_7__["tap"])(({ action, state }) => {
            switch (action.payload.role) {
                case 'admin':
                    return this.router.navigate(['/admin']);
                case 'auditor':
                    return this.router.navigate(['/audit']);
                case 'creator':
                case 'meta_creator':
                case 'publisher':
                case 'customer':
                    return this.router.navigate(['/catalog']);
                default:
                    return this.router.navigate(['/catalog']);
            }
        }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_7__["map"])((response) => ({ type: 'WALLET_LOAD_SUCCESS', payload: response })), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_7__["catchError"])((error, caught) => {
            console.error(error.message);
            this.store.dispatch({
                type: 'WALLET_LOAD_ERROR',
                payload: error.message,
            });
            return caught;
        }));
        // request Publication
        this.WalletRequestPublication$ = this.actions$.pipe(Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_2__["ofType"])('WALLET_REQUEST_PUBLICATION'), 
        // get state from store
        Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_7__["withLatestFrom"])(this.store, (action, state) => ({ action, state })), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_7__["flatMap"])(({ action, state }) => Object(rxjs__WEBPACK_IMPORTED_MODULE_5__["of"])([]).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_7__["tap"])(() => console.log('[effects][WALLET_REQUEST_PUBLICATION]', action, state)), 
        // wait until sodium is ready
        Object(tezos_wallet__WEBPACK_IMPORTED_MODULE_9__["initializeWallet"])(stateWallet => ({
            secretKey: state.wallet.selected.secretKey,
            publicKey: state.wallet.selected.publicKey,
            // for smart contract use manager address
            publicKeyHash: state.wallet.selected.publicKeyHash,
            // set tezos node
            node: state.app.tezos.node,
            type: 'web',
        })), 
        // transfer tokens
        Object(tezos_wallet__WEBPACK_IMPORTED_MODULE_9__["transaction"])(stateWallet => ({
            to: state.app.tezos.contract.catalog.address,
            amount: '0',
            fee: '0.1',
            parameters: {
                "entrypoint": "requestDataPublication",
                "value": {
                    "prim": "Pair",
                    "args": [{ "string": action.payload.data_id },
                        // default publisher address
                        { "string": "tz1epncWCL1vGFz1UgyTZHdE4v1u417ETJa9" }
                        // { "string": "tz1WCojrEZWrjenejUZmG8QNsMtKPELx2TFA" }
                    ]
                }
            },
        })), 
        // wait until operation is confirmed & moved from mempool to head
        Object(tezos_wallet__WEBPACK_IMPORTED_MODULE_9__["confirmOperation"])(stateWallet => ({
            injectionOperation: stateWallet.injectionOperation,
        })), 
        // enter back into zone.js so change detection works
        Object(_shared_utils_rxjs_operators__WEBPACK_IMPORTED_MODULE_8__["enterZone"])(this.zone))), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_7__["map"])((response) => ({ type: 'WALLET_REQUEST_PUBLICATION_SUCCESS', payload: response })), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_7__["catchError"])((error, caught) => {
            this.store.dispatch({
                type: 'WALLET_REQUEST_PUBLICATION_ERROR',
                payload: error.response,
            });
            return caught;
        }));
        // get transactions data from users big map
        this.WalletAllowPublication$ = this.actions$.pipe(Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_2__["ofType"])('WALLET_ALLOW_PUBLICATION'), 
        // get state from store
        Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_7__["withLatestFrom"])(this.store, (action, state) => ({ action, state })), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_7__["flatMap"])(({ action, state }) => Object(rxjs__WEBPACK_IMPORTED_MODULE_5__["of"])([]).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_7__["tap"])(() => console.log('[effects][WALLET_REQUEST_PUBLICATION]', action, state)), 
        // wait until sodium is ready
        Object(tezos_wallet__WEBPACK_IMPORTED_MODULE_9__["initializeWallet"])(stateWallet => ({
            secretKey: state.wallet.selected.secretKey,
            publicKey: state.wallet.selected.publicKey,
            // for smart contract use manager address
            publicKeyHash: state.wallet.selected.publicKeyHash,
            // set tezos node
            node: state.app.tezos.node,
            type: 'web',
        })), 
        // transfer tokens
        Object(tezos_wallet__WEBPACK_IMPORTED_MODULE_9__["transaction"])(stateWallet => ({
            to: state.app.tezos.contract.catalog.address,
            amount: '0',
            fee: '0.1',
            // allowDataPublication
            parameters: {
                "entrypoint": "allowDataPublication",
                "value": { "string": action.payload.data_id }
            },
        })), 
        // wait until operation is confirmed & moved from mempool to head
        Object(tezos_wallet__WEBPACK_IMPORTED_MODULE_9__["confirmOperation"])(stateWallet => ({
            injectionOperation: stateWallet.injectionOperation,
        })), 
        // enter back into zone.js so change detection works
        Object(_shared_utils_rxjs_operators__WEBPACK_IMPORTED_MODULE_8__["enterZone"])(this.zone))), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_7__["map"])((response) => ({ type: 'WALLET_ALLOW_PUBLICATION_SUCCESS', payload: response })), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_7__["catchError"])((error, caught) => {
            console.error(error);
            this.store.dispatch({
                type: 'WALLET_ALLOW_PUBLICATION_ERROR',
                payload: error.response,
            });
            return caught;
        }));
        // buyData
        this.WalletBuyData$ = this.actions$.pipe(Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_2__["ofType"])('WALLET_BUY_DATA'), 
        // get state from store
        Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_7__["withLatestFrom"])(this.store, (action, state) => ({ action, state })), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_7__["flatMap"])(({ action, state }) => Object(rxjs__WEBPACK_IMPORTED_MODULE_5__["of"])([]).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_7__["tap"])(() => console.log('[effects][WALLET_BUY_DATA]', action, state)), 
        // wait until sodium is ready
        Object(tezos_wallet__WEBPACK_IMPORTED_MODULE_9__["initializeWallet"])(stateWallet => ({
            secretKey: state.wallet.selected.secretKey,
            publicKey: state.wallet.selected.publicKey,
            // for smart contract use manager address
            publicKeyHash: state.wallet.selected.publicKeyHash,
            // set tezos node
            node: state.app.tezos.node,
            type: 'web',
        })), 
        // transfer tokens
        Object(tezos_wallet__WEBPACK_IMPORTED_MODULE_9__["transaction"])(stateWallet => ({
            to: state.app.tezos.contract.catalog.address,
            amount: '0',
            fee: '0.1',
            // buyData
            parameters: {
                "entrypoint": "buyData",
                "value": {
                    "prim": "Pair",
                    "args": [{
                            "prim": "Pair",
                            "args": [{ "string": action.payload.data_id },
                                { "string": Math.floor(Math.random() * 100000).toString() }]
                        },
                        { "string": Math.floor(Math.random() * 100000).toString() }]
                }
            },
        })), 
        // wait until operation is confirmed & moved from mempool to head
        Object(tezos_wallet__WEBPACK_IMPORTED_MODULE_9__["confirmOperation"])(stateWallet => ({
            injectionOperation: stateWallet.injectionOperation,
        })), 
        // enter back into zone.js so change detection works
        Object(_shared_utils_rxjs_operators__WEBPACK_IMPORTED_MODULE_8__["enterZone"])(this.zone))), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_7__["map"])((response) => ({ type: 'WALLET_BUY_DATA_SUCCESS', payload: response })), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_7__["catchError"])((error, caught) => {
            console.error(error);
            this.store.dispatch({
                type: 'WALLET_BUY_DATA_ERROR',
                payload: error.response,
            });
            return caught;
        }));
        // create data
        this.WalletCreateData$ = this.actions$.pipe(Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_2__["ofType"])('WALLET_CREATE_DATA'), 
        // get state from store
        Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_7__["withLatestFrom"])(this.store, (action, state) => ({ action, state })), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_7__["flatMap"])(({ action, state }) => Object(rxjs__WEBPACK_IMPORTED_MODULE_5__["of"])([]).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_7__["tap"])(() => console.log('[effects][WALLET_CREATE_DATA]', action, state)), 
        // wait until sodium is ready
        Object(tezos_wallet__WEBPACK_IMPORTED_MODULE_9__["initializeWallet"])(stateWallet => ({
            secretKey: state.wallet.selected.secretKey,
            publicKey: state.wallet.selected.publicKey,
            // for smart contract use manager address
            publicKeyHash: state.wallet.selected.publicKeyHash,
            // set tezos node
            node: state.app.tezos.node,
            type: 'web',
        })), 
        // transfer tokens
        Object(tezos_wallet__WEBPACK_IMPORTED_MODULE_9__["transaction"])(stateWallet => ({
            to: state.app.tezos.contract.catalog.address,
            amount: '0',
            fee: '0.1',
            // create data
            parameters: {
                "entrypoint": "createData",
                "value": {
                    "prim": "Pair",
                    "args": [{ "string": action.payload.data_id }, { "string": action.payload.keywords }]
                }
            },
        })), 
        // wait until operation is confirmed & moved from mempool to head
        Object(tezos_wallet__WEBPACK_IMPORTED_MODULE_9__["confirmOperation"])(stateWallet => ({
            injectionOperation: stateWallet.injectionOperation,
        })), 
        // enter back into zone.js so change detection works
        Object(_shared_utils_rxjs_operators__WEBPACK_IMPORTED_MODULE_8__["enterZone"])(this.zone))), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_7__["map"])((response) => ({ type: 'WALLET_CREATE_DATA_SUCCESS', payload: response })), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_7__["catchError"])((error, caught) => {
            console.error(error);
            this.store.dispatch({
                type: 'WALLET_CREATE_DATA_ERROR',
                payload: error.response,
            });
            return caught;
        }));
        // create data
        this.WalletCreateMETAData$ = this.actions$.pipe(Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_2__["ofType"])('WALLET_CREATE_META_DATA'), 
        // get state from store
        Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_7__["withLatestFrom"])(this.store, (action, state) => ({ action, state })), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_7__["flatMap"])(({ action, state }) => Object(rxjs__WEBPACK_IMPORTED_MODULE_5__["of"])([]).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_7__["tap"])(() => console.log('[effects][WALLET_CREATE_META_DATA]', action, state)), 
        // wait until sodium is ready
        Object(tezos_wallet__WEBPACK_IMPORTED_MODULE_9__["initializeWallet"])(stateWallet => ({
            secretKey: state.wallet.selected.secretKey,
            publicKey: state.wallet.selected.publicKey,
            // for smart contract use manager address
            publicKeyHash: state.wallet.selected.publicKeyHash,
            // set tezos node
            node: state.app.tezos.node,
            type: 'web',
        })), 
        // transfer tokens
        Object(tezos_wallet__WEBPACK_IMPORTED_MODULE_9__["transaction"])(stateWallet => ({
            to: state.app.tezos.contract.catalog.address,
            amount: '0',
            fee: '0.1',
            // createMetadata
            parameters: {
                "entrypoint": "createMetadata",
                "value": {
                    "prim": "Pair",
                    "args": [{
                            "prim": "Pair",
                            "args": [{ "string": action.payload.data_id },
                                { "string": action.payload.keywords }]
                        },
                        { "string": action.payload.meta_data_id }]
                }
            },
        })), 
        // wait until operation is confirmed & moved from mempool to head
        Object(tezos_wallet__WEBPACK_IMPORTED_MODULE_9__["confirmOperation"])(stateWallet => ({
            injectionOperation: stateWallet.injectionOperation,
        })), 
        // enter back into zone.js so change detection works
        Object(_shared_utils_rxjs_operators__WEBPACK_IMPORTED_MODULE_8__["enterZone"])(this.zone))), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_7__["map"])((response) => ({ type: 'WALLET_CREATE_META_DATA_SUCCESS', payload: response })), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_7__["catchError"])((error, caught) => {
            console.error(error);
            this.store.dispatch({
                type: 'WALLET_CREATE_META_DATA_ERROR',
                payload: error.response,
            });
            return caught;
        }));
    }
};
WalletEffects.ctorParameters = () => [
    { type: _ngrx_effects__WEBPACK_IMPORTED_MODULE_2__["Actions"] },
    { type: _ngrx_store__WEBPACK_IMPORTED_MODULE_3__["Store"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_4__["Router"] },
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_6__["HttpClient"] },
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["NgZone"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_2__["Effect"])()
], WalletEffects.prototype, "WalletRedirect$", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_2__["Effect"])()
], WalletEffects.prototype, "WalletBuyDataRedirect$", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_2__["Effect"])()
], WalletEffects.prototype, "WalletChange$", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_2__["Effect"])()
], WalletEffects.prototype, "WalletRequestPublication$", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_2__["Effect"])()
], WalletEffects.prototype, "WalletAllowPublication$", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_2__["Effect"])()
], WalletEffects.prototype, "WalletBuyData$", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_2__["Effect"])()
], WalletEffects.prototype, "WalletCreateData$", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_2__["Effect"])()
], WalletEffects.prototype, "WalletCreateMETAData$", void 0);
WalletEffects = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])()
], WalletEffects);



/***/ }),

/***/ "./src/app/wallet/wallet.reducer.ts":
/*!******************************************!*\
  !*** ./src/app/wallet/wallet.reducer.ts ***!
  \******************************************/
/*! exports provided: reducer */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reducer", function() { return reducer; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

const initialState = {
    ids: [
        'tz1VXDYKscRsAWm2ESVFQa3dzdWdapbSbDcm',
        'tz1dWBTTN38GCYEjTajVa5oTayw6H6d42uJX',
        'tz1epncWCL1vGFz1UgyTZHdE4v1u417ETJa9',
        'tz1igoyxEgLgTPVxU3JsBwgn4bcLSXTXuHdw',
        'tz1PkNVy8aM4TSciWZg99KexYjX622mXnx8j',
        'tz1WCojrEZWrjenejUZmG8QNsMtKPELx2TFA',
    ],
    entities: {
        tz1WCojrEZWrjenejUZmG8QNsMtKPELx2TFA: {
            name: 'Admin',
            role: 'admin',
            secretKey: 'edsk3hEtniBGLP2wqYnc1Lix1hhV74eEenRBTfxjHTRHP59R7BapMW',
            publicKey: 'edpkth42B7j7rvLeZWmufj28a7sEdbMBb9y16qgQmGHYGX4hPis9V4',
            publicKeyHash: 'tz1WCojrEZWrjenejUZmG8QNsMtKPELx2TFA',
        },
        tz1PkNVy8aM4TSciWZg99KexYjX622mXnx8j: {
            name: 'Auditor',
            role: 'auditor',
            secretKey: 'edsk3Xz7H9wY7fLX53VQ4fk4icwKtsSeAjoriKD9JHYSDtYvg8zjdu',
            publicKey: 'edpktigW7ixPdE2hV5ZtHkg2uenHgfqVTfjvQRwAkqo5cc2aYSKctn',
            publicKeyHash: 'tz1PkNVy8aM4TSciWZg99KexYjX622mXnx8j',
        },
        tz1VXDYKscRsAWm2ESVFQa3dzdWdapbSbDcm: {
            name: 'Creator',
            role: 'creator',
            secretKey: 'edsk4Q6r9wnDcwnnonojc1HYhNRfpk2MpsRF5VuJc5VGhs9K1XyXr4',
            publicKey: 'edpkvPUCDv4DYC37FvpXvc1ZfPYNVhTzU2xiqUTKDPDaQFmPw5UsA8',
            publicKeyHash: 'tz1VXDYKscRsAWm2ESVFQa3dzdWdapbSbDcm',
        },
        tz1dWBTTN38GCYEjTajVa5oTayw6H6d42uJX: {
            name: 'Meta Creator',
            role: 'meta_creator',
            secretKey: 'edsk48tjtJ1kv7kiyBJxJ1rYqFz1njNVa1G8kneTEonSbD3M4tJTaR',
            publicKey: 'edpku3TXHsE9kZdphTdYz6pSUQvkzAeUXgYmWGVs4AzYBdT12hD3CP',
            publicKeyHash: 'tz1dWBTTN38GCYEjTajVa5oTayw6H6d42uJX'
        },
        tz1epncWCL1vGFz1UgyTZHdE4v1u417ETJa9: {
            name: 'Publisher',
            role: 'publisher',
            secretKey: 'edsk3neLbXv2n2L4V3zR24cgWCFEWqzwPY5cp7K5N96Jwuq7ov6qfp',
            publicKey: 'edpku4h8cY57pWdxBWuoDKBRQg6MjSnV2oNAPyVqi3x9rSoUKNf5LE',
            publicKeyHash: 'tz1epncWCL1vGFz1UgyTZHdE4v1u417ETJa9'
        },
        tz1igoyxEgLgTPVxU3JsBwgn4bcLSXTXuHdw: {
            name: 'Customer',
            role: 'customer',
            secretKey: 'edsk2p9bj1F4aKYSi2cec7xKNS2SoQuwDn7rgX6rBzCqvrRH5BdhZZ',
            publicKey: 'edpkvLDoKFPXD57YPSnYp5HyPmibVFqYqvQc7hFFYsJfNYBEQLLNxY',
            publicKeyHash: 'tz1igoyxEgLgTPVxU3JsBwgn4bcLSXTXuHdw'
        }
    },
    selected: {
        name: 'Auditor',
        role: 'auditor',
        secretKey: 'edsk3Xz7H9wY7fLX53VQ4fk4icwKtsSeAjoriKD9JHYSDtYvg8zjdu',
        publicKey: 'edpktigW7ixPdE2hV5ZtHkg2uenHgfqVTfjvQRwAkqo5cc2aYSKctn',
        publicKeyHash: 'tz1PkNVy8aM4TSciWZg99KexYjX622mXnx8j',
    },
};
function reducer(state = initialState, action) {
    switch (action.type) {
        case 'WALLET_CHANGE': {
            return Object.assign({}, state, { selected: state.entities[action.payload.publicKeyHash] });
        }
        default:
            return state;
    }
}


/***/ }),

/***/ "./src/environments/environment.ts":
/*!*****************************************!*\
  !*** ./src/environments/environment.ts ***!
  \*****************************************/
/*! exports provided: environment */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "environment", function() { return environment; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

const environment = {
    production: false,
    tezos: {
        nodes: {
            main: {
                display: 'Mainnet',
                name: 'main',
                url: 'https://mainnet.simplestaking.com:3000',
                tzstats: {
                    url: 'https://tzstats.com/account/',
                    api: 'https://api.tzstats.com/',
                },
            },
            babylon: {
                display: 'Babylon',
                name: 'babylon',
                url: 'https://alphanet.simplestaking.com:3000',
                tzstats: {
                    url: 'https://cors-anywhere.herokuapp.com/https://babylonnet.tzstats.com/account/',
                    api: 'https://cors-anywhere.herokuapp.com/https://api.babylonnet.tzstats.com',
                },
            },
            local: {
                display: 'Babylon',
                name: 'babylon',
                url: 'https://cors-anywhere.herokuapp.com/46.101.160.245:8732',
                tzstats: {
                    url: 'https://babylonnet.tzstats.com/account/',
                    api: 'https://api.babylonnet.tzstats.com',
                },
            },
            zero: {
                display: 'Zeronet',
                name: 'zero',
                url: 'https://zeronet.simplestaking.com:3000',
                tzstats: {
                    url: 'https://zeronet.tzstats.com/account/',
                    api: 'https://api.zeronet.tzstats.com/',
                },
            },
        },
        contract: {
            catalog: {
                // address: 'KT1Nab4p6rGSAsWjgE3N41kR1yVRGtvcRphj'
                address: 'KT1MQh4zB32igNDkteq98YJd4jrv9zy5bhyC',
            }
        },
        default: "babylon",
    }
};


/***/ }),

/***/ "./src/main.ts":
/*!*********************!*\
  !*** ./src/main.ts ***!
  \*********************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/platform-browser-dynamic */ "./node_modules/@angular/platform-browser-dynamic/fesm2015/platform-browser-dynamic.js");
/* harmony import */ var _app_app_module__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./app/app.module */ "./src/app/app.module.ts");
/* harmony import */ var _environments_environment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./environments/environment */ "./src/environments/environment.ts");





if (_environments_environment__WEBPACK_IMPORTED_MODULE_4__["environment"].production) {
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["enableProdMode"])();
}
Object(_angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_2__["platformBrowserDynamic"])().bootstrapModule(_app_app_module__WEBPACK_IMPORTED_MODULE_3__["AppModule"])
    .catch(err => console.error(err));


/***/ }),

/***/ 0:
/*!***************************!*\
  !*** multi ./src/main.ts ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! /Users/jurajselep/Projects/prototype/app/src/main.ts */"./src/main.ts");


/***/ }),

/***/ 1:
/*!**********************!*\
  !*** util (ignored) ***!
  \**********************/
/*! no static exports found */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 2:
/*!**********************!*\
  !*** util (ignored) ***!
  \**********************/
/*! no static exports found */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 3:
/*!********************!*\
  !*** fs (ignored) ***!
  \********************/
/*! no static exports found */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 4:
/*!************************!*\
  !*** buffer (ignored) ***!
  \************************/
/*! no static exports found */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 5:
/*!************************!*\
  !*** crypto (ignored) ***!
  \************************/
/*! no static exports found */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })

},[[0,"runtime","vendor"]]]);
//# sourceMappingURL=main-es2015.js.map